
import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ROUTE_TRANSITION } from 'src/app/app.animation';
import { Location } from '@angular/common';
import { FormArray, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { HomePageService } from 'src/app/services/home-page.service';
import { Constant } from 'src/app/constant/constant';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CatalogPriceRulesService } from 'src/app/services/catalog-price-rules.service';
import { environment } from 'src/environments/environment';
import { ProductService } from 'src/app/services/product.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { ScrollbarComponent } from 'src/app/shared/scrollbar/scrollbar.component';
import { ScreenSizeService } from 'src/app/services/screen-size.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CommonService } from 'src/app/services/common.service';
import { ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { MatDialog } from '@angular/material/dialog';
import { CustomProductScopeService } from 'src/app/services/custom-product-scope.service';
import { ReviewandratingService } from 'src/app/services/reviewandrating.service';
import { ProductsService } from 'src/app/services/products.service';
import { IDelete, IDetect } from 'src/app/pages/pos/directive/barcode-put/bar-code-put.directive';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DynamicFormGroupService } from 'src/app/services/dynamic-form-group.service';
import { TextEditorComponent } from 'src/app/shared/text-editor/text-editor.component';
import { CopyTemplateComponent } from './copy-template/copy-template.component';
import { ConfigService } from 'src/app/services/config.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { EcommercetemplateComponent } from './ecommercetemplate/ecommercetemplate.component';
import { isThisSecond } from 'date-fns';
import { pl } from 'date-fns/locale';


@UntilDestroy()
@Component({
  selector: 'calsoft-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' },
})
export class TemplateComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  multiVendorPlan: boolean = false;

  @Input() value: any;
  @Input() title: string;
  @Input() filedName: any = [];
  @Input() filedName1: any = [];

  @Input() type: any = 1;

  @ViewChild(ScrollbarComponent, { static: true })
  scrollbar: ScrollbarComponent;

  @ViewChild('scrollMe') private myScrollContainer: ElementRef;

  protected _onDestroy = new Subject<void>();
  menu: any;
  text: string;
  valueInit: boolean = false;
  removedList: any = [];
  imagesToRemoved: any = [];
  imageError: boolean = false;
  drawerOpen = true;
  drawerMode = 'side';
  drawerDisableClose = true;
  create: any;
  updatepermission: any;
  newMediaGalleryList: any = [];
  modules: {};
  menuTilte: any;
  layoutRestrictionValue: any;
  layoutRestriction: boolean = false;
  empty: any;
  dotSaved: string;
  imageUrl: any;
  roundedleft: number;
  roundedtop: number;
  dotPrimaryIndex: any;
  dotSecondryIndex: any;
  tabledata: any[] = [{}];
  tabledata1: any[] = [{}];
  priceplandata: any;
  priceplandata1: any;
  types: any;
  duplicate: boolean = false;
  oldId: any;
  titleOld: any;
  priceplandata2: any;
  priceplandata3: any;
  priceplandata4: any;
  priceplandata5: any;
  priceplandata6: any;

  defaultIndex: number = 0;
  templateType: any;
  uuid: any;
  currentUuid: number;
  multiVendorPlanDuplication: boolean = false;
  constructor(
    private location: Location,
    private ecryptService: EcryptServiceService,
    private _formBuilder: UntypedFormBuilder,
    private homePageService: HomePageService,
    private snackBar: MatSnackBar,
    private router: Router,
    private catalogPriceRulesService: CatalogPriceRulesService,
    private reviewandratingService: ReviewandratingService,
    private productService: ProductService,
    private mediaMatcher: MediaMatcher,
    private screenSizeService: ScreenSizeService,
    private cd: ChangeDetectorRef,
    private commonService: CommonService,
    private dialog: MatDialog,
    private customProductScopeService: CustomProductScopeService,
    private dynamicFormGroupService: DynamicFormGroupService,
    private productsService: ProductsService,
    private route: ActivatedRoute,
    private configService: ConfigService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.modules = {
      formula: true,
      imageResize: {},
      syntax: true,
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [{ 'header': 1 }, { 'header': 2 }], // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
        [{ 'direction': 'rtl' }], // text direction
        [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['clean'], // remove formatting button
        ['link', 'image'], // link and image, video
      ],
    }
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }
  _form: UntypedFormGroup;
  mobileQuery = this.mediaMatcher.matchMedia('(max-width: 959px)');
  drawerOpen$ = this.screenSizeService.drawerOpen$;
  private _mobileQueryListener: () => void;

  homepageLimitedRestriction: boolean = false;


  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
    this._onDestroy.next();
    this._onDestroy.complete();
  }
  cancel() {
    this.location.back();
  }

  imageCount: any = [
    { id: 1, status: "1" },
    { id: 2, status: "2" },
    { id: 3, status: "3" },
    { id: 4, status: "4" }

  ]

  autoplay: any = [
    { "value": 1, "viewValue": "Yes" },
    { "value": 0, "viewValue": "No" },
  ]

  formLayoutType: any = [
    { "value": 1, "viewValue": "1" },
    { "value": 0, "viewValue": "2" },
    { "value": 2, "viewValue": "3" },
  ]

  autoplayString: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "0", "viewValue": "No" },
  ]

  formType: any = [
    { value: "0", viewValue: "Default" },
    { value: "1", viewValue: "Custom" },
    { value: "2", viewValue: "Login" }
  ]

  layoutMainType: any;

  ngOnInit(): void {

    let plan = localStorage.getItem('plan');

    if (plan != undefined && plan != null) {

      if (plan == '5' && this.type == 1) {

        this.multiVendorPlan = true

      }

      if (plan == '5' && this.router.url.includes("/duplicatePage/")) {

        this.multiVendorPlanDuplication = true;

      }


    }


    if (this.router.url.includes("/duplicatePage/")) {

      this.templateType = this.route.snapshot.params['oldUuidId'];

      console.log(this.route.snapshot.params);

    }

    let object = {
      value: '0', viewValue: this.title,
    }
    this.links.push(object)

    this.menuTilte = this.title;
    this.title = this.title
    this.menu = 0
    this.text = 'Save';

    this._form = this._formBuilder.group({
      conditions: this._formBuilder.array([this.createLayoutForm()]),
    });
    this.getResource();
    this.getcustomScope();
    this.getAllProduct();
    this.getdynamicForm();
    this.getdynamicFormList();
    this.getproductScopeList();
    this.productScopeYFilter();

    this.dynmaicFormYFilter();


    this.getConfigData();


    this.dotSaved = 'Save';

    console.log(this._form);





  }




  getConfigData() {
    const encryptedData = localStorage.getItem('configSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        this.layoutMainType = data['layoutMainType'];

      }
      catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }

  textalignmenttype: any = [
    { value: "start", viewValue: "Start" },
    { value: "center", viewValue: "Center" },
    { value: "end", viewValue: "End" }
  ]
  position: any = [
    { "value": "0", "viewValue": "Start" },
    { "value": "1", "viewValue": "Center" },
    { "value": "2", "viewValue": "Fully" },
  ]
  displayType: any = [
    { viewValue: "Price Plan", value: "Plan" },
    { viewValue: "Product Scope", value: "ProductScope" },
  ]

  position1: any = [
    { "value": "0", "viewValue": "Start" },
    { "value": "1", "viewValue": "Center" },
    { "value": "2", "viewValue": "End" },
  ]

  tabLayout: any = [
    { "value": "0", "viewValue": "Start" },
    { "value": "1", "viewValue": "Center" },
    { "value": "2", "viewValue": "End" },
    { "value": "3", "viewValue": "Button" },
    { "value": "4", "viewValue": "Text" },
    { "value": "5", "viewValue": "Button 2" },
    { "value": "6", "viewValue": "Vertical" },
    { "value": "7", "viewValue": "Button 3" },
    { "value": "8", "viewValue": "Menu Type" },
    { "value": "9", "viewValue": "Button 4" },
    { "value": "10", "viewValue": "Button 5" },
  ]

  position2: any = [
    { "value": "start", "viewValue": "Start" },
    { "value": "center", "viewValue": "Center" },
    { "value": "end", "viewValue": "End" },
  ]

  buttonTypes: any = [
    { "value": "0", "viewValue": "Type 1" },
    { "value": "1", "viewValue": "Type 2" },
    { "value": "2", "viewValue": "Type 3" },
    { "value": "3", "viewValue": "Type 4" },
    { "value": "4", "viewValue": "Type 5" },
    { "value": "5", "viewValue": "Type 6" },
    { "value": "6", "viewValue": "Type 7" },
    { "value": "7", "viewValue": "Type 8" },
    { "value": "8", "viewValue": "Type 9" },
  ]

  mapview: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "2", "viewValue": "No" },

  ]

  getResource() {
    this.commonService
      .getAllAccessForResource(
        this.router.url.includes('blogSection') ? ResourceAccess.BLOGSECTION :
          ResourceAccess.LAYOUT)
      .subscribe((data: any) => {

        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {
          this.getValue();
          this.getproductScope();
          this.create = data.create;
          this.updatepermission = data.update;


          if (!this.create && data.restriction.length > 0) {
            this.layoutRestriction = false;
          } else if (data.restriction.length > 0) {
            this.layoutRestrictionValue = data.restriction[0].layoutRestriction
            this.layoutRestriction = true;

          }


          this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
          this._mobileQueryListener = () => {
            this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
            this.cd.detectChanges();
          };
          this.router.events
            .pipe(
              filter((event) => event instanceof NavigationEnd),
              filter(() => this.mobileQuery.matches),
              untilDestroyed(this)
            )
            .subscribe(() => this.closeDrawer());


          if (data.restriction.length > 0) {
            this.homepageLimitedRestriction = data.restriction[0].homepageLimitedRestriction == 1 ? true : false;
          }
          if (this.homepageLimitedRestriction) {
            this.filedName1
          } else {
            this.filedName
          }


        }
      });
  }

  drawerChange(drawerOpen: boolean) {
    this.screenSizeService.drawerOpen.next(drawerOpen);
  }

  openDrawer() {
    this.screenSizeService.drawerOpen.next(true);
    this.cd.markForCheck();
  }

  closeDrawer() {
    this.screenSizeService.drawerOpen.next(false);
    this.cd.markForCheck();
  }

  scrollToBottom() {
    this.scrollbar.scrollbarRef.getScrollElement().scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  }

  scrollToBottomPosition() {
    // this.scrollbar.scrollbarRef.getScrollElement().scrollTo({
    //   behavior: 'smooth',
    //   top: this.scrollbar.scrollbarRef.getContentElement().clientHeight
    // });
    //   try {
    //     this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    // } catch(err) { }   
  }


  getValue() {
    this.getData();
    this.getCategoryList();
    this.categoryYFilter();
    this.getAllCategory();
  }

  createLayoutForm(typeValue: string = ''): UntypedFormGroup {
    return this._formBuilder.group({
      layoutConfigId: new UntypedFormControl(0),

      position: new UntypedFormControl(0),

      type: [typeValue, [Validators.required]],

      value: [0, [Validators.required]],

      title: ['', [Validators.required]],
      layout: [''],
      customField1: ['type1'],
      customField2: [''],
      customField3: ['',],
      customField4: [''],
      customField5: [''],
      customField6: [''],
      customField7: [''],
      customField8: [''],
      customField9: [''],
      customField10: [''],
      categoryId1: new UntypedFormControl(0),
      categoryId2: new UntypedFormControl(0),
      categoryId3: new UntypedFormControl(0),
      categoryId4: new UntypedFormControl(0),
      categoryId5: [0],
      categoryId6: new UntypedFormControl(0),
      sortOrder: 'price,DESC',
      pageType: new UntypedFormControl(this.type),
      images: new UntypedFormArray([]),
      uuid: ['Primary'],
      fontFamily: [''],
      height: [''],
      width: [''],
      gapBetweenImage: [''],
      customField11: [''],
      customField12: [''],
      customField13: [0],
      customField14: [''],
      customField15: [''],
      customField16: [''],
      customField17: [''],
      customField18: [''],
      customField19: [''],
      customField20: [''],
      customField21: [''],
      customField22: [''],
      customField23: ['1'],
      customField24: [''],
      categoryId7: new UntypedFormControl(0),
      categoryId8: new UntypedFormControl(0),
      categoryId9: new UntypedFormControl(0),
      categoryId10: new UntypedFormControl(0),
      categoryId11: [0],
      categoryId12: new UntypedFormControl(0),
      heightMob: [''],
      widthMob: [''],
      displayMobileImage: [''],
      mobileGapBetweenImage: [''],
      altImage: [''],
      customField25: [''],
      customField26: [''],
      customField27: [''],
      customField28: [''],
      customField29: [''],
      customField30: [''],
      customField31: [''],
      customField32: [''],
      customField33: [''],
      customField34: [''],
      customField35: [''],
      customField36: [''],
      customField37: [''],
      customField38: [''],
      customField39: [''],
      customField40: [''],
      linkedinConversationId: [''],
      pagesTitle: [''],
      layoutSub: new UntypedFormArray([]),
    });
  }



  get f() {
    return this._form.controls;
  }
  get t() {
    return this.f.images as UntypedFormArray;
  }

  onChange(e, i) {
    this._form.value.conditions[i].value = 'images';

    this._form.patchValue(this._form.value);
    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(i);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;

    const numberOfImgCount = e.value || 0;
    if (value.length < numberOfImgCount) {
      for (let i = value.length; i < numberOfImgCount; i++) {
        value.push(
          this._formBuilder.group({
            valueId: new UntypedFormControl(0),
            img: ['', Validators.required],
            catId: new UntypedFormControl(0),
            navigation: new UntypedFormControl(0),
            navigatedUrl: new UntypedFormControl(0),
            type: new UntypedFormControl(1),
            customField1: ['',],
            customField2: ['type1',],
            customField3: ['',],
            customField4: ['',],
            customField5: ['',],
            customField6: ['',],
            customField7: [''],
            customField8: ['',],
            customField9: ['',],
            customField10: ['',],
            customField11: [''],
            customField12: [''],
            customField13: [0],
            customField14: ['',],
            customField15: ['',],
            customField16: ['',],
            customField17: ['',],
            customField18: ['',],
            customField19: ['',],
            customField20: ['',],
            customField21: [''],
            customField22: [''],
            customField23: [''],
            customField24: [''],
            altImage: [''],
            autoplay: [''],
            customField25: [''],
            customField26: [''],
            customField27: [''],
            customField28: [''],
            customField29: [''],
            customField30: [''],
            customField31: [''],
            customField32: [''],
            customField33: [''],
            customField34: [''],
            customField35: [''],
            customField36: [''],
            customField37: [''],
            customField38: [''],
            customField39: [''],
            customField40: [''],
            subChild: new UntypedFormArray([]),

          })
        );
      }
    } else {
      for (let i = value.length; i >= numberOfImgCount; i--) {
        value.removeAt(i);
      }
    }
  }

  addImages(i) {

    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(i);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    value.push(
      this._formBuilder.group({
        valueId: new UntypedFormControl(0),
        img: [''],
        catId: new UntypedFormControl(0),
        navigation: new UntypedFormControl(0),
        navigatedUrl: new UntypedFormControl(0),
        type: new UntypedFormControl(1),
        customField1: ['',],
        customField2: [''],
        customField3: ['',],
        customField4: ['',],
        customField5: ['',],
        customField6: ['',],
        customField7: [''],
        customField8: [''],
        customField9: [''],
        customField10: [''],
        customField11: [''],
        customField12: [''],
        customField13: [0],
        customField14: [''],
        customField15: [''],
        customField16: [''],
        customField17: ['',],
        customField18: [''],
        customField19: ['',],
        customField20: ['',],
        customField21: [''],
        customField22: [''],
        customField23: [''],
        customField24: [''],
        customField25: [''],
        customField26: [''],
        customField27: [''],
        customField28: [''],
        customField29: [''],
        customField30: [''],
        customField31: [''],
        customField32: [''],
        customField33: [''],
        customField34: [''],
        customField35: [''],
        customField36: [''],
        customField37: [''],
        customField38: [''],
        customField39: [''],
        customField40: [''],
      })
    );
  }

  addSub(i) {
    if (this._form && this._form.get('conditions')) {
      const arrayControl = this._form.get('conditions') as UntypedFormArray;
      const item = arrayControl.at(i);
      if (item && item.get('layoutSub')) {
        const value = item.get('layoutSub') as UntypedFormArray;
        value.push(
          this._formBuilder.group({
            valueId: new UntypedFormControl(0),
            img: [''],
            catId: new UntypedFormControl(0),
            navigation: new UntypedFormControl(0),
            navigatedUrl: new UntypedFormControl(0),
            type: new UntypedFormControl(1),
            customField1: [''],
            customField2: [''],
            customField3: [''],
            customField4: [''],
            customField5: [''],
            customField6: [''],
            customField7: [''],
            customField8: [''],
            customField9: [''],
            customField10: [''],
            customField11: [''],
            customField12: [''],
            customField13: [0],
            customField14: [''],
            customField15: [''],
            customField16: [''],
            customField17: [''],
            customField18: [''],
            customField19: [''],
            customField20: [''],
            customField21: [''],
            customField22: [''],
            customField23: [''],
            customField24: [''],
            customField25: [''],
            customField26: [''],
            customField27: [''],
            customField28: [''],
            customField29: [''],
            customField30: [''],
            customField31: [''],
            customField32: [''],
            customField33: [''],
            customField34: [''],
            customField35: [''],
            customField36: [''],
            customField37: [''],
            customField38: [''],
            customField39: [''],
            customField40: [''],
          })
        );
      }
    }
  }







  addTabLayout(i) {

    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(i);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    value.push(
      this._formBuilder.group({
        valueId: new UntypedFormControl(0),
        img: [''],
        catId: new UntypedFormControl(0),
        navigation: new UntypedFormControl(0),
        navigatedUrl: new UntypedFormControl(0),
        type: new UntypedFormControl(1),
        customField1: ['',],
        customField2: [''],
        customField3: ['',],
        customField4: ['',],
        customField5: ['',],
        customField6: ['',],
        customField7: [''],
        customField8: [''],
        customField9: [''],
        customField10: [''],
        customField11: [''],
        customField12: [''],
        customField13: [''],
        customField14: [''],
        customField15: [''],
        customField16: [''],
        customField17: ['',],
        customField18: [''],
        customField19: ['',],
        customField20: ['',],
        customField21: [''],
        customField22: [''],
        customField23: [''],
        customField24: [''],
        customField25: [''],
        customField26: [''],
        customField27: [''],
        customField28: [''],
        customField29: [''],
        customField30: [''],
        customField31: [''],
        customField32: [''],
        customField33: [''],
        customField34: [''],
        customField35: [''],
        customField36: [''],
        customField37: [''],
        customField38: [''],
        customField39: [''],
        customField40: [''],
        subChild: this._formBuilder.array([])
      })
    );
  }

  addbrandCarosel(i) {

    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(i);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    value.push(
      this._formBuilder.group({
        valueId: new UntypedFormControl(0),
        img: [''],
        catId: new UntypedFormControl(0),
        navigation: new UntypedFormControl(0),
        navigatedUrl: new UntypedFormControl(0),
        type: new UntypedFormControl(1),
        customField1: ['',],
        customField2: [''],
        customField3: ['',],
        customField4: ['',],
        customField5: ['',],
        customField6: ['',],
        customField7: [''],
        customField8: [''],
        customField9: [''],
        customField10: [''],
        customField11: [''],
        customField12: [''],
        customField13: [''],
        customField14: [''],
        customField15: [''],
        customField16: [''],
        customField17: ['',],
        customField18: [''],
        customField19: ['',],
        customField20: ['',],
        customField21: [''],
        customField22: [''],
        customField23: [''],
        customField24: [''],
        customField25: [''],
        customField26: [''],
        customField27: [''],
        customField28: [''],
        customField29: [''],
        customField30: [''],
        customField31: [''],
        customField32: [''],
        customField33: [''],
        customField34: [''],
        customField35: [''],
        customField36: [''],
        customField37: [''],
        customField38: [''],
        customField39: [''],
        customField40: [''],
        subChild: this._formBuilder.array([])
      })
    );
  }

  addcustomGroupLayout(i) {

    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(i);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    value.push(
      this._formBuilder.group({
        valueId: new UntypedFormControl(0),
        img: [''],
        catId: new UntypedFormControl(0),
        navigation: new UntypedFormControl(0),
        navigatedUrl: new UntypedFormControl(0),
        type: new UntypedFormControl(1),
        customField1: ['',],
        customField2: [''],
        customField3: ['',],
        customField4: ['',],
        customField5: ['',],
        customField6: ['',],
        customField7: [''],
        customField8: [''],
        customField9: [''],
        customField10: [''],
        customField11: [''],
        customField12: [''],
        customField13: [''],
        customField14: [''],
        customField15: [''],
        customField16: [''],
        customField17: ['',],
        customField18: [''],
        customField19: ['',],
        customField20: ['',],
        customField21: [''],
        customField22: [''],
        customField23: [''],
        customField24: [''],
        customField25: [''],
        customField26: [''],
        customField27: [''],
        customField28: [''],
        customField29: [''],
        customField30: [''],
        customField31: [''],
        customField32: [''],
        customField33: [''],
        customField34: [''],
        customField35: [''],
        customField36: [''],
        customField37: [''],
        customField38: [''],
        customField39: [''],
        customField40: [''],
      })
    );
  }

  addbannerVedio(i) {

    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(i);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    if (value.length === 0) {
      value.push(
        this._formBuilder.group({
          valueId: new UntypedFormControl(0),
          img: [''],
          catId: new UntypedFormControl(0),
          navigation: new UntypedFormControl(0),
          navigatedUrl: new UntypedFormControl(0),
          type: new UntypedFormControl(1),
          customField1: ['',],
          customField2: [''],
          customField3: ['',],
          customField4: ['',],
          customField5: ['',],
          customField6: ['',],
          customField7: [''],
          customField8: [''],
          customField9: [''],
          customField10: [''],
          customField11: [''],
          customField12: [''],
          customField13: [''],
          customField14: [''],
          customField15: [''],
          customField16: [''],
          customField17: ['',],
          customField18: [''],
          customField19: ['',],
          customField20: ['',],
          customField21: [''],
          customField22: [''],
          customField23: [''],
          customField24: [''],
          customField25: [''],
          customField26: [''],
          customField27: [''],
          customField28: [''],
          customField29: [''],
          customField30: [''],
          customField31: [''],
          customField32: [''],
          customField33: [''],
          customField34: [''],
          customField35: [''],
          customField36: [''],
          customField37: [''],
          customField38: [''],
          customField39: [''],
          customField40: [''],
        })
      );
    }
  }

  addFaq(i) {

    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(i);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    value.push(
      this._formBuilder.group({
        valueId: new UntypedFormControl(0),
        img: [''],
        catId: new UntypedFormControl(0),
        navigation: new UntypedFormControl(0),
        navigatedUrl: new UntypedFormControl(0),
        type: new UntypedFormControl(1),
        customField1: ['',],
        customField2: [''],
        customField3: ['',],
        customField4: ['',],
        customField5: ['',],
        customField6: ['',],
        customField7: [''],
        customField8: [''],
        customField9: [''],
        customField10: [''],
        customField11: [''],
        customField12: [''],
        customField13: [''],
        customField14: [''],
        customField15: [''],
        customField16: [''],
        customField17: ['',],
        customField18: [''],
        customField19: ['',],
        customField20: ['',],
        customField21: [''],
        customField22: [''],
        customField23: [''],
        customField24: [''],
        customField25: [''],
        customField26: [''],
        customField27: [''],
        customField28: [''],
        customField29: [''],
        customField30: [''],
        customField31: [''],
        customField32: [''],
        customField33: [''],
        customField34: [''],
        customField35: [''],
        customField36: [''],
        customField37: [''],
        customField38: [''],
        customField39: [''],
        customField40: [''],
      })
    );
  }

  addslideBanner(i) {

    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(i);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    value.push(
      this._formBuilder.group({
        valueId: new UntypedFormControl(0),
        img: [''],
        catId: new UntypedFormControl(0),
        navigation: new UntypedFormControl(0),
        navigatedUrl: new UntypedFormControl(0),
        type: new UntypedFormControl(1),
        customField1: ['',],
        customField2: [''],
        customField3: ['',],
        customField4: ['',],
        customField5: ['',],
        customField6: ['',],
        customField7: [''],
        customField8: [''],
        customField9: [''],
        customField10: [''],
        customField11: [''],
        customField12: [''],
        customField13: [''],
        customField14: [''],
        customField15: [''],
        customField16: [''],
        customField17: ['',],
        customField18: [''],
        customField19: ['',],
        customField20: ['',],
        customField21: [''],
        customField22: [''],
        customField23: [''],
        customField24: [''],
        customField25: [''],
        customField26: [''],
        customField27: [''],
        customField28: [''],
        customField29: [''],
        customField30: [''],
        customField31: [''],
        customField32: [''],
        customField33: [''],
        customField34: [''],
        customField35: [''],
        customField36: [''],
        customField37: [''],
        customField38: [''],
        customField39: [''],
        customField40: [''],
      })
    );
  }

  onChangeImageTab(e, i, j) {
    if (e.value == 'Image') {
      this._form.patchValue(this._form.value);
      //  this.addImagesArraySub(i,j);
    }
  }

  addImagesArraySub(i, j) {

    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(i);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    var subitem = value.at(j);
    let subValue = (<UntypedFormArray>subitem.get('subChild')) as UntypedFormArray;
    subValue.push(
      this._formBuilder.group({
        valueId: new UntypedFormControl(0),
        img: [''],
        catId: new UntypedFormControl(0),
        navigation: new UntypedFormControl(0),
        navigatedUrl: new UntypedFormControl(0),
        type: new UntypedFormControl(1),
        customField1: ['',],
        customField2: [''],
        customField3: ['',],
        customField4: ['',],
        customField5: ['',],
        customField6: ['',],
        customField7: [''],
        customField8: [''],
        customField9: [''],
        customField10: [''],
        customField11: [''],
        customField12: [''],
        customField13: [0],
        customField14: [''],
        customField15: [''],
        customField16: [''],
        customField17: ['',],
        customField18: [''],
        customField19: ['',],
        customField20: ['',],
        customField21: [''],
        customField22: [''],
        customField23: [''],
        customField24: [''],
        customField25: [''],
        customField26: [''],
        customField27: [''],
        customField28: [''],
        customField29: [''],
        customField30: [''],
        customField31: [''],
        customField32: [''],
        customField33: [''],
        customField34: [''],
        customField35: [''],
        customField36: [''],
        customField37: [''],
        customField38: [''],
        customField39: [''],
        customField40: [''],
      })
    );
  }


  onChangeImageNew(e, i) {

    if (e == 'freeText') {
      this._form.value.conditions[i].layout = '1';
      this._form.patchValue(this._form.value);
    } else if (e.value == 'categoryCarousel') {
      this._form.value.conditions[i].layout = '1';
      this._form.value.conditions[i].title = 'categoryCarousel';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'brandsCarousel') {
      this._form.value.conditions[i].layout = 'banner';
      this._form.value.conditions[i].value = 'banner';
      this._form.value.conditions[i].title = 'banner';
      this._form.patchValue(this._form.value);
      this.addbrandCarosel(i);
    }
    else if (e == 'image') {

      this._form.value.conditions[i].title = 'image';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'blogData') {

      this._form.value.conditions[i].title = 'blogData';
      this._form.patchValue(this._form.value);
    }

    else if (e == 'banner') {
      this._form.value.conditions[i].layout = 'banner';
      this._form.value.conditions[i].value = 'banner';
      this._form.value.conditions[i].title = 'banner';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'textWithImage') {
      this._form.value.conditions[i].layout = 1;

      this._form.patchValue(this._form.value);

      let e = {
        value: 1
      }
      this.onChange(e, i)
    } else if (e == 'bannertextWithImage') {
      this._form.value.conditions[i].layout = 'bannertextWithImage';
      this._form.value.conditions[i].value = 'bannertextWithImage';
      this._form.value.conditions[i].title = '';

      this._form.patchValue(this._form.value);
      this.addImages(i);
    } else if (e == 'faq') {
      this._form.value.conditions[i].layout = 'faq';
      this._form.value.conditions[i].value = 'faq';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addFaq(i);

    } else if (e == 'slideBanner') {
      this._form.value.conditions[i].layout = 'slideBanner';
      this._form.value.conditions[i].value = 'slideBanner';
      this._form.patchValue(this._form.value);
      this.addslideBanner(i);
    } else if (e == 'scrollText') {
      this._form.value.conditions[i].layout = 'scrollText';
      this._form.value.conditions[i].value = 'scrollText';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    } else if (e == '360View') {
      this._form.value.conditions[i].layout = '360View';
      this._form.value.conditions[i].value = '360View';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    } else if (e == 'tabLayout') {
      this._form.value.conditions[i].layout = 'tabLayout';
      this._form.value.conditions[i].value = 'tabLayout';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addTabLayout(i);
    }
    else if (e == 'bannerVideo') {
      this._form.value.conditions[i].layout = 'bannerVideo';
      this._form.value.conditions[i].value = 'bannerVideo';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e == 'SearchWithBackground') {
      this._form.value.conditions[i].layout = 'SearchWithBackground';
      this._form.value.conditions[i].value = 'SearchWithBackground';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e == 'mp4') {
      this._form.value.conditions[i].layout = 'mp4';
      this._form.value.conditions[i].value = 'mp4';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);

    } else if (e == 'storeLocations') {
      this._form.value.conditions[i].layout = 'storeLocations';
      this._form.value.conditions[i].value = 'storeLocations';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'bannerTextWithButton') {
      this._form.value.conditions[i].layout = 'bannerTextWithButton';
      this._form.value.conditions[i].value = 'bannerTextWithButton';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'customerReviews') {
      this._form.value.conditions[i].layout = 'customerReviews';
      this._form.value.conditions[i].value = 'customerReviews';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'carouselwithProduct') {
      this._form.value.conditions[i].layout = 'carouselwithProduct';
      this._form.value.conditions[i].value = 'carouselwithProduct';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'TexthoverWithImage') {
      this._form.value.conditions[i].layout = 'TexthoverWithImage';
      this._form.value.conditions[i].value = 'TexthoverWithImage';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'customGroupLayout') {
      this._form.value.conditions[i].layout = 'customGroupLayout';
      this._form.value.conditions[i].value = 'customGroupLayout';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'categoryCarouselWithBanner') {
      this._form.value.conditions[i].layout = 'categoryCarouselWithBanner';
      this._form.value.conditions[i].value = 'categoryCarouselWithBanner';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'typeForm') {
      this._form.value.conditions[i].layout = 'typeForm';
      this._form.value.conditions[i].value = 'typeForm';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'table') {
      this._form.value.conditions[i].layout = 'table';
      this._form.value.conditions[i].value = 'table';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'serviceLayout') {
      this._form.value.conditions[i].layout = 'serviceLayout';
      this._form.value.conditions[i].value = 'serviceLayout';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e == 'stepFlowLayout') {
      this._form.value.conditions[i].layout = 'stepFlowLayout';
      this._form.value.conditions[i].value = 'stepFlowLayout';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'ScrollNavigationwithImage') {
      this._form.value.conditions[i].layout = 'ScrollNavigationwithImage';
      this._form.value.conditions[i].value = 'ScrollNavigationwithImage';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'ScrollWithTextAndImage') {
      this._form.value.conditions[i].layout = 'ScrollWithTextAndImage';
      this._form.value.conditions[i].value = 'ScrollWithTextAndImage';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'FreeTextWithBanner') {
      this._form.value.conditions[i].layout = 'FreeTextWithBanner';
      this._form.value.conditions[i].value = 'FreeTextWithBanner';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'ImageWithTextTwo') {
      this._form.value.conditions[i].layout = 'ImageWithTextTwo';
      this._form.value.conditions[i].value = 'ImageWithTextTwo';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }

    else if (e == 'ScrollWithAnimatedReview') {
      this._form.value.conditions[i].layout = 'ScrollWithAnimatedReview';
      this._form.value.conditions[i].value = 'ScrollWithAnimatedReview';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'affliatesectionbackground') {
      this._form.value.conditions[i].layout = 'affliatesectionbackground';
      this._form.value.conditions[i].value = 'affliatesectionbackground';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'ScrollWithAnimationUltimate') {
      this._form.value.conditions[i].layout = 'ScrollWithAnimationUltimate';
      this._form.value.conditions[i].value = 'ScrollWithAnimationUltimate';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'ComparisonCorrection') {
      this._form.value.conditions[i].layout = 'ComparisonCorrection';
      this._form.value.conditions[i].value = 'ComparisonCorrection';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }

    else if (e == 'appvideobackground') {
      this._form.value.conditions[i].layout = 'appvideobackground';
      this._form.value.conditions[i].value = 'appvideobackground';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'appherovideobackground') {
      this._form.value.conditions[i].layout = 'appherovideobackground';
      this._form.value.conditions[i].value = 'appherovideobackground';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'CRMComparisonTable') {
      this._form.value.conditions[i].layout = 'CRMComparisonTable';
      this._form.value.conditions[i].value = 'CRMComparisonTable';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }


    else if (e == 'ScrollWithTextAndAnimatedImage') {
      this._form.value.conditions[i].layout = 'ScrollWithTextAndAnimatedImage';
      this._form.value.conditions[i].value = 'ScrollWithTextAndAnimatedImage';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'PyramidWithTextAndImage') {
      this._form.value.conditions[i].layout = 'PyramidWithTextAndImage';
      this._form.value.conditions[i].value = 'PyramidWithTextAndImage';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'NumberCount') {
      this._form.value.conditions[i].layout = 'NumberCount';
      this._form.value.conditions[i].value = 'NumberCount';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e == 'OfferTiming') {
      this._form.value.conditions[i].layout = 'OfferTiming';
      this._form.value.conditions[i].value = 'OfferTiming';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }

    else if (e == 'OrderSuccess') {
      this._form.value.conditions[i].layout = 'OrderSuccess';
      this._form.value.conditions[i].value = 'OrderSuccess';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }


    else if (e == 'buttonType') {
      this._form.value.conditions[i].layout = 'buttonType';
      this._form.value.conditions[i].value = 'buttonType';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'textwithform') {
      this._form.value.conditions[i].layout = 'textwithform';
      this._form.value.conditions[i].value = 'textwithform';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'textWithText') {
      this._form.value.conditions[i].layout = 'textWithText';
      this._form.value.conditions[i].value = 'textWithText';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'imageContainerWithText') {
      this._form.value.conditions[i].layout = 'imageContainerWithText';
      this._form.value.conditions[i].value = 'imageContainerWithText';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    } else if (e == 'serviceContactButton') {
      this._form.value.conditions[i].layout = 'serviceContactButton';
      this._form.value.conditions[i].value = 'serviceContactButton';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'scrolltextwithform') {
      this._form.value.conditions[i].layout = 'scrolltextwithform';
      this._form.value.conditions[i].value = 'scrolltextwithform';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e == 'iconTextWithBackground') {
      this._form.value.conditions[i].layout = 'iconTextWithBackground';
      this._form.value.conditions[i].value = 'iconTextWithBackground';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    } else if (e == 'vedioBanner') {
      this._form.value.conditions[i].layout = 'vedioBanner';
      this._form.value.conditions[i].value = 'vedioBanner';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    } else if (e == 'servicePlan') {
      this._form.value.conditions[i].layout = 'servicePlan';
      this._form.value.conditions[i].value = 'servicePlan';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
      this.addSub(i);
    }
    else if (e == 'sliderImageWithText') {
      this._form.value.conditions[i].layout = 'sliderImageWithText';
      this._form.value.conditions[i].value = 'sliderImageWithText';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e == 'partners') {
      this._form.value.conditions[i].layout = 'partners';
      this._form.value.conditions[i].value = 'partners';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e == 'partnerData') {

      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }

    else if (e == 'stepperform') {
      this._form.value.conditions[i].layout = 'stepperform';
      this._form.value.conditions[i].value = 'stepperform';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e == 'DoubleImagescroll') {
      this._form.value.conditions[i].layout = 'DoubleImagescroll';
      this._form.value.conditions[i].value = 'DoubleImagescroll';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }

    else if (e == 'TextAnimationwithtext') {
      this._form.value.conditions[i].layout = 'TextAnimationwithtext';
      this._form.value.conditions[i].value = 'TextAnimationwithtext';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }

    else if (e == 'ComparisonCorrection') {
      this._form.value.conditions[i].layout = 'ComparisonCorrection';
      this._form.value.conditions[i].value = 'ComparisonCorrection';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }


    else if (e == 'footer') {
      this._form.value.conditions[i].layout = 'footer';
      this._form.value.conditions[i].value = 'footer';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addTabLayout(i);
    }

    else if (e == 'dragdrop') {
      this._form.value.conditions[i].layout = 'dragdrop';
      this._form.value.conditions[i].value = 'dragdrop';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
      this.addSub(i);
    }

    else if (e == 'subscription') {
      this._form.value.conditions[i].layout = 'subscription';
      this._form.value.conditions[i].value = 'subscription';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e == 'scrollableImageForm') {
      this._form.value.conditions[i].layout = 'scrollableImageForm';
      this._form.value.conditions[i].value = 'scrollableImageForm';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }

    else if (e == 'emiCalculator') {
      this._form.value.conditions[i].layout = 'emiCalculator';
      this._form.value.conditions[i].value = 'emiCalculator';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e == 'TypingWithBanner') {
      this._form.value.conditions[i].layout = 'TypingWithBanner';
      this._form.value.conditions[i].value = 'TypingWithBanner';
      this._form.value.conditions[i].title = 'TypingWithBanner';
      this._form.patchValue(this._form.value);
      this.addbrandCarosel(i);

    } else if (e == 'livePrice') {
      this._form.value.conditions[i].layout = 'livePrice';
      this._form.value.conditions[i].value = 'livePrice';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
  }



  onChangeImage(e, i) {

    if (e.value == 'freeText') {
      this._form.value.conditions[i].layout = '1';
      this._form.patchValue(this._form.value);
    } else if (e.value == 'categoryCarousel') {
      this._form.value.conditions[i].layout = '1';
      this._form.value.conditions[i].title = 'categoryCarousel';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'brandsCarousel') {
      this._form.value.conditions[i].layout = 'banner';
      this._form.value.conditions[i].value = 'banner';
      this._form.value.conditions[i].title = 'banner';
      this._form.patchValue(this._form.value);
      this.addbrandCarosel(i);
    }
    else if (e.value == 'image') {

      this._form.value.conditions[i].title = 'image';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'blogData') {

      this._form.value.conditions[i].title = 'blogData';
      this._form.patchValue(this._form.value);
    }

    else if (e.value == 'banner') {
      this._form.value.conditions[i].layout = 'banner';
      this._form.value.conditions[i].value = 'banner';
      this._form.value.conditions[i].title = 'banner';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'textWithImage') {
      this._form.value.conditions[i].layout = 1;

      this._form.patchValue(this._form.value);

      let e = {
        value: 1
      }
      this.onChange(e, i)
    } else if (e.value == 'bannertextWithImage') {
      this._form.value.conditions[i].layout = 'bannertextWithImage';
      this._form.value.conditions[i].value = 'bannertextWithImage';
      this._form.value.conditions[i].title = '';

      this._form.patchValue(this._form.value);
      this.addImages(i);
    } else if (e.value == 'faq') {
      this._form.value.conditions[i].layout = 'faq';
      this._form.value.conditions[i].value = 'faq';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addFaq(i);

    } else if (e.value == 'slideBanner') {
      this._form.value.conditions[i].layout = 'slideBanner';
      this._form.value.conditions[i].value = 'slideBanner';
      this._form.patchValue(this._form.value);
      this.addslideBanner(i);
    } else if (e.value == 'scrollText') {
      this._form.value.conditions[i].layout = 'scrollText';
      this._form.value.conditions[i].value = 'scrollText';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    } else if (e.value == '360View') {
      this._form.value.conditions[i].layout = '360View';
      this._form.value.conditions[i].value = '360View';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    } else if (e.value == 'tabLayout') {
      this._form.value.conditions[i].layout = 'tabLayout';
      this._form.value.conditions[i].value = 'tabLayout';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addTabLayout(i);
    }

    else if (e.value == 'bannerVideo') {
      this._form.value.conditions[i].layout = 'bannerVideo';
      this._form.value.conditions[i].value = 'bannerVideo';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e.value == 'SearchWithBackground') {
      this._form.value.conditions[i].layout = 'SearchWithBackground';
      this._form.value.conditions[i].value = 'SearchWithBackground';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e.value == 'mp4') {
      this._form.value.conditions[i].layout = 'mp4';
      this._form.value.conditions[i].value = 'mp4';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);

    } else if (e.value == 'storeLocations') {
      this._form.value.conditions[i].layout = 'storeLocations';
      this._form.value.conditions[i].value = 'storeLocations';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'bannerTextWithButton') {
      this._form.value.conditions[i].layout = 'bannerTextWithButton';
      this._form.value.conditions[i].value = 'bannerTextWithButton';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'customerReviews') {
      this._form.value.conditions[i].layout = 'customerReviews';
      this._form.value.conditions[i].value = 'customerReviews';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'carouselwithProduct') {
      this._form.value.conditions[i].layout = 'carouselwithProduct';
      this._form.value.conditions[i].value = 'carouselwithProduct';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'TexthoverWithImage') {
      this._form.value.conditions[i].layout = 'TexthoverWithImage';
      this._form.value.conditions[i].value = 'TexthoverWithImage';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'customGroupLayout') {
      this._form.value.conditions[i].layout = 'customGroupLayout';
      this._form.value.conditions[i].value = 'customGroupLayout';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'categoryCarouselWithBanner') {
      this._form.value.conditions[i].layout = 'categoryCarouselWithBanner';
      this._form.value.conditions[i].value = 'categoryCarouselWithBanner';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'typeForm') {
      this._form.value.conditions[i].layout = 'typeForm';
      this._form.value.conditions[i].value = 'typeForm';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'table') {
      this._form.value.conditions[i].layout = 'table';
      this._form.value.conditions[i].value = 'table';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'serviceLayout') {
      this._form.value.conditions[i].layout = 'serviceLayout';
      this._form.value.conditions[i].value = 'serviceLayout';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e.value == 'stepFlowLayout') {
      this._form.value.conditions[i].layout = 'stepFlowLayout';
      this._form.value.conditions[i].value = 'stepFlowLayout';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'ScrollNavigationwithImage') {
      this._form.value.conditions[i].layout = 'ScrollNavigationwithImage';
      this._form.value.conditions[i].value = 'ScrollNavigationwithImage';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'buttonType') {
      this._form.value.conditions[i].layout = 'buttonType';
      this._form.value.conditions[i].value = 'buttonType';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'textwithform') {
      this._form.value.conditions[i].layout = 'textwithform';
      this._form.value.conditions[i].value = 'textwithform';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'textWithText') {
      this._form.value.conditions[i].layout = 'textWithText';
      this._form.value.conditions[i].value = 'textWithText';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'imageContainerWithText') {
      this._form.value.conditions[i].layout = 'imageContainerWithText';
      this._form.value.conditions[i].value = 'imageContainerWithText';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    } else if (e.value == 'serviceContactButton') {
      this._form.value.conditions[i].layout = 'serviceContactButton';
      this._form.value.conditions[i].value = 'serviceContactButton';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'scrolltextwithform') {
      this._form.value.conditions[i].layout = 'scrolltextwithform';
      this._form.value.conditions[i].value = 'scrolltextwithform';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e.value == 'iconTextWithBackground') {
      this._form.value.conditions[i].layout = 'iconTextWithBackground';
      this._form.value.conditions[i].value = 'iconTextWithBackground';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    } else if (e.value == 'vedioBanner') {
      this._form.value.conditions[i].layout = 'vedioBanner';
      this._form.value.conditions[i].value = 'vedioBanner';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    } else if (e.value == 'servicePlan') {
      this._form.value.conditions[i].layout = 'servicePlan';
      this._form.value.conditions[i].value = 'servicePlan';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
      this.addSub(i);
    }
    else if (e.value == 'sliderImageWithText') {
      this._form.value.conditions[i].layout = 'sliderImageWithText';
      this._form.value.conditions[i].value = 'sliderImageWithText';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e.value == 'partners') {
      this._form.value.conditions[i].layout = 'partners';
      this._form.value.conditions[i].value = 'partners';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e.value == 'partnerData') {

      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }

    else if (e.value == 'stepperform') {
      this._form.value.conditions[i].layout = 'stepperform';
      this._form.value.conditions[i].value = 'stepperform';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e.value == 'DoubleImagescroll') {
      this._form.value.conditions[i].layout = 'DoubleImagescroll';
      this._form.value.conditions[i].value = 'DoubleImagescroll';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }

    else if (e.value == 'TextAnimationwithtext') {
      this._form.value.conditions[i].layout = 'TextAnimationwithtext';
      this._form.value.conditions[i].value = 'TextAnimationwithtext';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }

    else if (e.value == 'footer') {
      this._form.value.conditions[i].layout = 'footer';
      this._form.value.conditions[i].value = 'footer';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addTabLayout(i);
    }

    else if (e.value == 'dragdrop') {
      this._form.value.conditions[i].layout = 'dragdrop';
      this._form.value.conditions[i].value = 'dragdrop';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
      this.addSub(i);
    }

    else if (e.value == 'subscription') {
      this._form.value.conditions[i].layout = 'subscription';
      this._form.value.conditions[i].value = 'subscription';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }
    else if (e.value == 'scrollableImageForm') {
      this._form.value.conditions[i].layout = 'scrollableImageForm';
      this._form.value.conditions[i].value = 'scrollableImageForm';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
      this.addImages(i);
    }

    else if (e.value == 'emiCalculator') {
      this._form.value.conditions[i].layout = 'emiCalculator';
      this._form.value.conditions[i].value = 'emiCalculator';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
    else if (e.value == 'TypingWithBanner') {
      this._form.value.conditions[i].layout = 'TypingWithBanner';
      this._form.value.conditions[i].value = 'TypingWithBanner';
      this._form.value.conditions[i].title = 'TypingWithBanner';
      this._form.patchValue(this._form.value);
      this.addbrandCarosel(i);
    } else if (e.value == 'livePrice') {
      this._form.value.conditions[i].layout = 'livePrice';
      this._form.value.conditions[i].value = 'livePrice';
      this._form.value.conditions[i].title = '';
      this._form.patchValue(this._form.value);
    }
  }

  getData() {


    if (this.router.url.includes("/duplicatePage/")) {
      this.duplicate = true;
      this.titleOld = this.route.snapshot.params['title']
      this.oldId = this.route.snapshot.params['oldUuidId']
      this.value = this.route.snapshot.params['newUuid']
    }


    if (this.router.url.includes("/duplicatePage/")
      && this.router.url.includes("/copytemplate")
    ) {
      this.titleOld = this.route.snapshot.params['title']
      this.oldId = this.route.snapshot.params['oldUuidId']
      this.value = this.route.snapshot.params['newUuid']

      this.homePageService.copyTemplate(this.value).subscribe(
        (res: any) => {
          this.layout = res;



          this.editLayout(res);


        },
        (error) => { }
      );



    } else {


      this.homePageService.getLayoutDetails(this.value).subscribe(
        (res: any) => {
          this.layout = res;

          console.log("layout", res);


          if (this.multiVendorPlan) {

            if (this.layout.length == 0 && !this.router.url.includes("/home-page-construction")) {

              this.homePageService.getPrimaryDetals().subscribe(
                (res: any) => {
                  if (res != null || res != undefined || res != '') {
                    this.currentUuid = 1;
                    this.uuid = res[0];
                    this.currentUuid = 1;
                    if (this.uuid != null) {
                      this.router.navigate([`page/duplicatePage/${this.title}/${this.currentUuid}/${this.uuid}`]);
                    }
                  }

                },
                (error) => { }
              );

            } else {
              this.editLayout(res);
            }

          } else {
            this.editLayout(res);
          }




        },
        (error) => { }
      );

    }




  }

  editLayout(layout: any) {
    this._form.setControl('conditions', this.editLayoutDetails(layout));
  }

  editLayoutDetails(layout: any): UntypedFormArray {
    const formArray = new UntypedFormArray([]);

    layout.forEach(s => {
      if (s.type == 'table' && (s.customField33 == 2 || s.customField33 == 13 || s.customField33 == 4 || s.customField33 == 10)) {

        //this.tabledata = JSON.parse(s.customField34);
        // this.tabledata1 = JSON.parse(s.customField30);
        if (s.customField32 !== null && this.isValidJson(s.customField32)) {
          this.priceplandata = JSON.parse(s.customField32);
        }
      }
      if (s.type == 'table' && s.customField33 == 3) {
        if (s.customField33 !== null && this.isValidJson(s.customField33)) {
          this.priceplandata1 = JSON.parse(s.customField31);
        }
      }

      if (s.type == 'table' && s.customField33 == 1) {

        if (s.customField34 !== null && this.isValidJson(s.customField34)) {
          this.tabledata = JSON.parse(s.customField34);
        }
        // this.tabledata = JSON.parse(s.customField34);
      }

      if (s.type == 'table' && s.customField33 == 5) {
        if (s.customField30 !== null && this.isValidJson(s.customField30)) {
          this.priceplandata2 = JSON.parse(s.customField30);
        }
      }
      if (s.type == 'table' && s.customField33 == 6) {
        if (s.customField33 !== null && this.isValidJson(s.customField33)) {
          this.priceplandata3 = JSON.parse(s.customField29);
        }
      }

      if (s.type == 'table' && s.customField33 == 7) {
        if (s.customField30 !== null && this.isValidJson(s.customField30)) {
          this.priceplandata2 = JSON.parse(s.customField30);
        }
      }

      if (s.type == 'table' && s.customField33 == 12) {
        if (s.customField30 !== null && this.isValidJson(s.customField30)) {
          this.priceplandata2 = JSON.parse(s.customField30);
        }
      }

      if (s.type == 'table' && s.customField33 == 9) {
        if (s.customField30 !== null && this.isValidJson(s.customField30)) {
          this.priceplandata4 = JSON.parse(s.customField30);
        }
      }
      if (s.type == 'table' && s.customField33 == 11) {
        if (s.customField30 !== null && this.isValidJson(s.customField30)) {
          this.priceplandata1 = JSON.parse(s.customField30);
        }
      }
      if (s.type == 'table' && s.customField33 == 15) {
        if (s.customField30 !== null && this.isValidJson(s.customField30)) {
          this.priceplandata5 = JSON.parse(s.customField30);
        }
      }
      if (s.type == 'table' && s.customField33 == 16) {
        if (s.customField30 !== null && this.isValidJson(s.customField30)) {
          this.priceplandata6 = JSON.parse(s.customField30);
        }
      }


      formArray.push(
        this._formBuilder.group({
          layoutConfigId: this.router.url.includes("/duplicatePage/") ? 0 : s.layoutConfigId,
          position: s.position,
          type: s.type,
          value: s.type == 'contactForm' ?
            parseInt(s.value) : s.type == 'category' ?
              parseInt(s.value) : s.type == 'otherCustomization' ?
                parseInt(s.value) : s.type == 'productScope' ?
                  parseInt(s.value) : s.type == 'carouselwithProduct' ?
                    parseInt(s.value) : s.type == 'customGroupLayout' ?
                      parseInt(s.value) : s.type == 'tabLayout' ?
                        parseInt(s.value) : s.type == 'table' ?
                          parseInt(s.value) : s.type == 'textwithform' ?
                            parseInt(s.value) : s.type == 'subscription' ?
                              parseInt(s.value) : s.type == 'scrollableImageForm' ?
                                parseInt(s.value) : s.type == 'DoubleImagescroll' ?
                                  parseInt(s.value) : s.type == 'vedioBanner' ?
                                    parseInt(s.value) : s.type == 'scrolltextwithform' ? parseInt(s.value) : s.value,
          title: this.getTitle(s.title, s.type),
          layout: s.type == 'category' ? s.layout : s.type == 'productScope' ? s.layout : s.type == 'otherCustomization' ? s.layout : s.type == 'carouselwithProduct' ? s.layout : s.type == 'tabLayout' ? s.layout : parseInt(s.layout),
          sortOrder: s.sortOrder,
          customField1: s.customField1,
          customField2: s.type == 'textWithImage' ? s.categoryId6 == 1 ? s.customField2
            : parseInt(s.customField2) : s.customField2,
          customField3: s.customField3,
          customField4: s.customField4,
          customField5: s.type === 'buttonType' ? parseInt(s.customField5) : s.customField5,
          customField6: s.type === 'buttonType' ? parseInt(s.customField6) : s.customField6,
          customField7: s.type === 'contactForm' ? parseInt(s.customField7) : s.customField7,
          customField8: s.customField8,
          customField9: s.type == 'bannerTextWithButton' ? s.customField9 : s.type == 'scrolltextwithform' ? s.customField9 : s.type == 'image' ? s.customField9 == '' ? 1 : parseInt(s.customField9) : parseInt(s.customField9),
          customField10: s.type == 'bannerTextWithButton' ? s.customField10 : s.type == 'image' ? s.customField10 == '' ? 'type1' : s.customField10 : s.customField10,
          categoryId1: s.categoryId1,
          categoryId2: s.categoryId2,
          categoryId3: s.categoryId3,
          categoryId4: s.categoryId4,
          categoryId5: s.categoryId5,
          categoryId6: s.categoryId6,
          images: this.setValueforImages(s.images, s),
          pageType: this.multiVendorPlanDuplication ? 1 : s.pageType,
          uuid: this.duplicate ? this.oldId : s.uuid,
          fontFamily: s.fontFamily,
          height: s.height,
          width: s.width,
          gapBetweenImage: s.gapBetweenImage,
          customField11: s.customField11,
          customField12: s.customField12,
          customField13: s.customField13,
          customField14: s.customField14,
          customField15: s.customField15,
          customField16: s.customField16,
          customField17: s.customField17,
          customField18: s.customField18,
          customField19: s.customField3 == 'ProductScope' ? parseInt(s.customField19) : s.customField19,
          customField20: s.customField20,
          customField21: s.customField21,
          customField22: s.customField22,
          customField23: s.customField23,
          customField24: s.customField24,
          customField25: s.customField25,
          customField26: s.customField26,
          customField27: s.customField27,
          customField28: s.customField28,
          customField29: s.customField29,
          customField30: s.customField30,
          customField31: s.customField31,
          customField32: s.customField32,
          customField33: s.customField33,
          customField34: s.customField34,
          customField35: s.customField35,
          customField36: s.customField36,
          customField37: s.customField37,
          customField38: s.customField38,
          customField39: s.customField39,
          customField40: s.customField40,
          linkedinConversationId: s.linkedinConversationId,
          categoryId7: s.categoryId7,
          categoryId8: s.categoryId8,
          categoryId9: s.categoryId9,
          categoryId10: s.categoryId10,
          categoryId11: s.categoryId11,
          categoryId12: s.categoryId12,
          heightMob: s.heightMob,
          widthMob: s.widthMob,
          displayMobileImage: s.displayMobileImage,
          mobileGapBetweenImage: s.mobileGapBetweenImage,
          altImage: s.altImage,
          pagesTitle: s.pagesTitle,
          layoutSub: this.setValueforlayoutSub(s.layoutSub, s),

        })
      );





    });

    return formArray;
  }

  isValidJson(jsonString: string): boolean {
    try {
      JSON.parse(jsonString);
      return true;
    } catch (e) {
      return false;
    }
  }



  setValueforSubChild(image: any, data: any) {

    const formArray = new UntypedFormArray([]);
    image.forEach((s, index) => {

      formArray.push(
        this._formBuilder.group({
          valueId: this.router.url.includes("/duplicatePage/") ? 0 : s.valueId,
          img: this.router.url.includes("/duplicatePage/") ? '' : s.img,
          navigation: s.navigation,
          catId: s.catId,
          navigatedUrl: s.navigatedUrl,
          type: s.type,
          customField1: s.customField1,
          customField2: s.customField2 == '' ? "type1" : s.customField2,
          customField3: s.customField3,
          customField4: data['customField3'] == 'Category' ? parseInt(s.customField4) : s.customField4,
          customField5: data['customField3'] == 'ProductScope' ? parseInt(s.customField5) : s.customField5,
          customField6: this.router.url.includes("/duplicatePage/") ? '' : s.customField6,
          customField7: s.customField7,
          customField8: s.customField8,
          customField9: s.customField9,
          customField10: s.customField10,
          customField11: s.customField11,
          customField12: s.customField12,
          customField13: s.customField13,
          customField14: s.customField14,
          customField15: s.customField15,
          customField16: s.customField16,
          customField17: s.customField17,
          customField18: s.customField18,
          customField19: s.customField3 == 'ProductScope' ? parseInt(s.customField19) : s.customField19,
          customField20: s.customField20,
          customField21: s.customField21,
          customField22: data['type'] == 'banner' && s.customField22 == '' ? 1 : data['type'] == 'banner' ? parseInt(s.customField22) : s.customField22,
          customField23: s.customField23,
          customField24: data['type'] == 'images' ? parseInt(s.customField24 == '' ? 0 : s.customField24) : s.customField24,
          customField25: s.customField25,
          customField26: s.customField26,
          customField27: s.customField27,
          customField28: s.customField28,
          customField29: s.customField29,
          customField30: s.customField30,
          customField31: s.customField31,
          customField32: s.customField32,
          customField33: s.customField33,
          customField34: s.customField34,
          customField35: s.customField35,
          customField36: s.customField36,
          customField37: s.customField37,
          customField38: s.customField38,
          customField39: s.customField39,
          customField40: s.customField40,

          altImage: s.altImage,
          autoplay: s.autoplay,
        })
      );
    });


    return formArray;
  }

  getTitle(value, type) {


    if (type == 'banner' || type == 'image' || type == 'categoryCarousel' || type == 'brandsCarousel') {

      value = value;

    } else {
      value = value;
    }

    return value;
  }

  setValueforlayoutSub(image: any, data: any) {
    const formArray = new UntypedFormArray([]);
    image.forEach((s, index) => {
      formArray.push(
        this._formBuilder.group({
          valueId: this.router.url.includes("/duplicatePage/") ? 0 : s.valueId,
          img: s.img,
          navigation: s.navigation,
          catId: s.catId,
          navigatedUrl: s.navigatedUrl,
          type: s.type,
          customField1: s.customField1,
          customField2: s.customField2 == '' ? "type1" : s.customField2,
          customField3: s.customField3,
          customField4: s.customField3 == 'Category' ? parseInt(s.customField4) : s.customField4,
          customField5: data['type'] == 'servicePlan' ? parseInt(s.customField5) : (s.customField3 == 'ProductScope' ? parseInt(s.customField5) : s.customField5),
          customField6: s.customField6,
          customField7: s.customField7,
          customField8: s.customField8,
          customField9: s.customField9,
          customField10: s.customField10,
          customField11: s.customField11,
          customField12: s.customField12,
          customField13: s.customField13,
          customField14: s.customField14,
          customField15: s.customField15,
          customField16: s.customField16,
          customField17: s.customField17,
          customField18: s.customField18,
          customField19: s.customField3 == 'ProductScope' ? parseInt(s.customField19) : s.customField19,
          customField20: s.customField20,
          customField21: s.customField21,
          customField22: data['type'] == 'banner' && s.customField22 == '' ? 1 : data['type'] == 'banner' ? parseInt(s.customField22) : s.customField22,
          customField23: s.customField23,
          customField24: s.customField24,
          customField25: s.customField25,
          customField26: s.customField26,
          customField27: s.customField27,
          customField28: s.customField28,
          customField29: s.customField29,
          customField30: s.customField30,
          customField31: s.customField31,
          customField32: s.customField32,
          customField33: s.customField33,
          customField34: s.customField34,
          customField35: s.customField35,
          customField36: s.customField36,
          customField37: s.customField37,
          customField38: s.customField38,
          customField39: s.customField39,
          customField40: s.customField40,

          altImage: s.altImage,
          autoplay: s.autoplay,
        })
      );
    });


    return formArray;
  }

  setValueforImages(image: any, data: any) {

    const formArray = new UntypedFormArray([]);
    image.forEach((s, index) => {

      formArray.push(
        this._formBuilder.group({
          valueId: this.router.url.includes("/duplicatePage/") ? 0 : s.valueId,
          img: this.router.url.includes("/duplicatePage/") ? '' : s.img,
          navigation: s.navigation,
          catId: s.catId,
          navigatedUrl: s.navigatedUrl,
          type: s.type,
          customField1: s.customField1,
          customField2: s.customField2 == '' ? "type1" : s.customField2,
          customField3: s.customField3,
          customField4: s.customField3 == 'Category' ? parseInt(s.customField4) : s.customField4,
          customField5: s.customField3 == 'ProductScope' ? parseInt(s.customField5) : s.customField5,
          customField6: s.customField6,
          customField7: s.customField7,
          customField8: s.customField8,
          customField9: s.customField9,
          customField10: s.customField10,
          customField11: s.customField11,
          customField12: s.customField12,
          customField13: s.customField13,
          customField14: s.customField14,
          customField15: s.customField15,
          customField16: s.customField16,
          customField17: s.customField17,
          customField18: s.customField18,
          customField19: s.customField3 == 'ProductScope' ? parseInt(s.customField19) : s.customField19,
          customField20: s.customField20,
          customField21: s.customField21,
          customField22: data['type'] == 'banner' && s.customField22 == '' ? 1 : data['type'] == 'banner' ? parseInt(s.customField22) : data['type'] == 'stepperform' ? parseInt(s.customField22) : s.customField22,
          customField23: s.customField23,
          customField24: s.customField24,
          customField25: s.customField25,
          customField26: s.customField26,
          customField27: s.customField27,
          customField28: s.customField28,
          customField29: s.customField29,
          customField30: s.customField30,
          customField31: s.customField31,
          customField32: s.customField32,
          customField33: s.customField33,
          customField34: s.customField34,
          customField35: s.customField35,
          customField36: s.customField36,
          customField37: s.customField37,
          customField38: s.customField38,
          customField39: s.customField39,
          customField40: s.customField40,

          altImage: s.altImage,
          autoplay: s.autoplay,
          subChild: this.setValueforSubChild(s.subChild, s),
        })
      );
    });


    return formArray;
  }

  // selectCategory(catId, j, i) {
  //   if (j == 0) {
  //     this._form.value.conditions[i].customField4 = catId
  //   } else if (j == 1) {
  //     this._form.value.conditions[i].customField6 = catId
  //   } else if (j == 2) {
  //     this._form.value.conditions[i].customField7 = catId
  //   } else if (j == 3) {
  //     this._form.value.conditions[i].customField8 = catId
  //   }
  //   this._form.patchValue(this._form.value)

  // }

  // categoryID = new FormControl(0)

  // selectCategoryBanner(catId, j, i) {



  //     this._form.value.conditions[i].customField2 = catId

  //   this._form.patchValue(this._form.value)

  // }

  links: any = [

    // { value: '1', viewValue: 'Design' },
  ];

  menuLink(i) {
    this.menu = i;
  }

  back() {
    this.location.back();
  }

  getDatas(event) {
    this.tabledata = event;
  }

  handleSetData(event) {
    this.priceplandata = event;
  }

  handleSetData1(event) {
    this.priceplandata1 = event;
  }

  handleSetData2(event) {
    this.priceplandata2 = event;
  }

  handleSetData3(event) {
    this.priceplandata3 = event;
  }
  handleSetData4(event) {
    this.priceplandata4 = event;
  }
  handleSetData5(event) {
    this.priceplandata5 = event;
  }
  handleSetData6(event) {
    this.priceplandata6 = event;
  }

  category: any;
  resultDropdown: Object;

  layout: any = [
    // { viewValue: 'Lightening Deals', value: 'Type 1', type: 'type-1' },
    { viewValue: 'Product Carousel', value: 'Type 1', type: 'type-2' },
    { viewValue: 'Top Products', value: 'Type 2', type: 'type-3' },
  ];

  layout1: any = [
    // { viewValue: 'Lightening Deals', value: 'Type 1', type: 'type-1' },
    { viewValue: 'Product Carousel', value: 'Type 1', type: 'type-2' },
    { viewValue: 'Top Products', value: 'Type 2', type: 'type-3' },
  ];


  blogType: any = [
    { "value": 0, "viewValue": "Type-1" },
    { "value": 1, "viewValue": "Type-2" },
  ]

  partnerType: any = [
    { "value": 0, "viewValue": "Type-1" },
    { "value": 1, "viewValue": "Type-2" },
  ]


  booleanFieldNumber: any = [
    { "value": 0, "viewValue": "Type-1" },
    { "value": 1, "viewValue": "Type-2" },
  ]


  toggleType: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": '2', "viewValue": "No" },
    { "value": '3', "viewValue": "None" },
  ]


  headerType: any = [
    { "value": 0, "viewValue": "Type-1" },
    { "value": 1, "viewValue": "Type-2" },
    { "value": 2, "viewValue": "Type-3" },
    { "value": 3, "viewValue": "Type-4" },
    { "value": 4, "viewValue": "Type-5" },
  ]

  tablayouttype: any = [
    { "value": "1", "viewValue": "Type 1" },
    { "value": "2", "viewValue": "Type 2" },
  ]

  tabheaderType: any = [
    { "value": "1", "viewValue": "Type-1" },
    { "value": '2', "viewValue": "Type-2" },
    { "value": '3', "viewValue": "Type-3" },
  ]

  mp4VedioType: any = [
    { "value": "1", "viewValue": "Video" },
    { "value": '2', "viewValue": "Video Id" },
    // { "value": '3', "viewValue": "Type-3" },
  ]

  booleanFieldNumber1: any = [
    { "value": 1, "viewValue": "Yes" },
    { "value": 0, "viewValue": "No" },
  ]

  taxType: any = [
    { "value": 'Inclusive', "viewValue": "Inclusive" },
    { "value": 'Exclusive', "viewValue": "Exclusive" },
  ]
  TypingbannerType: any = [
    { "value": '1', "viewValue": "Type 1" },
    { "value": '2', "viewValue": "Type 2" },
  ]

  booleanFieldString1: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "0", "viewValue": "No" },
  ]
  booleanFieldString2: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "0", "viewValue": "No" },
  ]

  Enabletable: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "0", "viewValue": "No" },
  ]

  buttonType: any = [
    { "value": "0", "viewValue": "Type-1" },
    { "value": "1", "viewValue": "Type-2" },
    { "value": "2", "viewValue": "Type-3" },
    { "value": "3", "viewValue": "Type-4" },
  ]

  layoutType2: any = [
    { id: "0", status: "Type 1" },
    { id: "1", status: "Type 2" },
    { id: "2", status: "Type 3" },
    { id: "3", status: "Type 4" },
    { id: "4", status: "Type 5" },
    { id: "5", status: "Type 6" },
    { id: "6", status: "Type 7" },
    { id: "7", status: "Type 8" },
  ]

  categoryCarouselType: any = [
    { id: "0", status: "Type 1" },
    { id: "1", status: "Type 2" },
    { id: "2", status: "Type 3" },
    // { id: "3", status: "Type 4" },
    // { id: "4", status: "Type 5" }
  ]

  lookbacktype: any = [
    { id: "0", status: "Type 1" },
    { id: "1", status: "Type 2" },
    { id: "2", status: "Type 3" },
  ]


  backType: any = [
    { "value": "0", "viewValue": "Type 1" },
    { "value": "1", "viewValue": "Type 2" },
  ]

  imageType: any = [
    { "value": "0", "viewValue": "Left" },
    { "value": "1", "viewValue": "Right" },
  ]

  vedioBannerType: any = [
    { "value": "0", "viewValue": "Video" },
    { "value": "1", "viewValue": "Image" },
    { "value": "2", "viewValue": "Pdf" },
  ]

  sliderType: any = [
    { "value": "1", "viewValue": "Type 1" },
    { "value": "2", "viewValue": "Type 2" },
  ]

  scrolltype: any = [
    { "value": "1", "viewValue": "Type 1" },
    { "value": "2", "viewValue": "Type 2" },
    { "value": "3", "viewValue": "Type 3" },
    { "value": "4", "viewValue": "Type 4" },
  ]

  titleType: any = [
    { "value": "0", "viewValue": "Type-1" },
    { "value": "1", "viewValue": "Type-2" },
  ]


  TextanimationType: any = [
    { "value": "0", "viewValue": "Type-1" },
    { "value": "1", "viewValue": "Type-2" },

  ]

  faqtypes: any = [
    { "value": "0", "viewValue": "Type-1" },
    { "value": "1", "viewValue": "Type-2" },
    { "value": "2", "viewValue": "Type-3" },
    { "value": "3", "viewValue": "Type-4" },
    { "value": "4", "viewValue": "Type-5" },
    { "value": "5", "viewValue": "Type-6" },
    { "value": "6", "viewValue": "Type-7" },
    { "value": "7", "viewValue": "Type-8" },
    { "value": "8", "viewValue": "Type-9" },
  ]

  stepFlowLayout: any = [
    { value: "0", viewValue: "Type 1" },
    { value: "1", viewValue: "Type 2" },
  ]
  topsectionEnable: any = [
    { value: "0", viewValue: "Yes" },
    { value: "1", viewValue: "No" },
  ]
  SectionsChange: any = [
    { value: "vertical", viewValue: "Vertical" },
    { value: "horizontal", viewValue: "horizontal" },
  ]
  imagetype: any = [
    { value: "0", viewValue: "Type 1" },
    { value: "1", viewValue: "Type 2" },
  ]

  emiCalculatorLayout: any = [
    { value: "0", viewValue: "Type 1" },
    { value: "1", viewValue: "Type 2" },
    { value: "2", viewValue: "Type 3" },
  ]

  imageType2: any = [
    { id: "0", status: "Type 1" },
    { id: "1", status: "Type 2" },
    { id: "2", status: "Type 3" },
    { id: "3", status: "Type 4" },
    { id: "4", status: "Type 5" },
    { id: "5", status: "Type 6" },
    { id: "6", status: "Type 7" },
    { id: "7", status: "Type 8" },
    { id: "8", status: "Type 9" },
    { id: "9", status: "Type 10" },
    { id: "10", status: "Type 11" },
    { id: "11", status: "Type 12" },
    { id: "12", status: "Type 13" },
    { id: "13", status: "Type 14" },
    { id: "14", status: "Type 15" },
    { id: "15", status: "Type 16" },
    { id: "16", status: "Type 17" },
    { id: "17", status: "Type 18" },
    { id: "18", status: "Type 19" },
    { id: "19", status: "Type 20" },
    { id: "20", status: "Type 21" },
    { id: "21", status: "Type 22" },
    { id: "22", status: "Type 23" },
  ]

  service_Layout: any = [
    { viewValue: '1', value: 'Type 1' },
    { viewValue: '2', value: 'Type 2' },
    { viewValue: '3', value: 'Type 3' },
    { viewValue: '4', value: 'Type 4' },
    { viewValue: '5', value: 'Type 5' },
    { viewValue: '6', value: 'Type 6' },
    { viewValue: '7', value: 'Type 7' },
    { viewValue: '8', value: 'Type 8' },
  ];

  searchlayout: any = [
    { viewValue: '1', value: 'Type 1' },
    { viewValue: '2', value: 'Type 2' },

  ];

  productlayouttype: any = [
    { viewValue: '1', value: 'Type 1' },
    { viewValue: '2', value: 'Type 2' },

  ];


  displayInline: any = [
    { viewValue: '1', value: 'Same Line' },
    { viewValue: '2', value: 'Next Line' },
    { viewValue: '3', value: 'None' },
  ];


  brand_type: any = [
    { viewValue: '1', value: 'Type 1' },
    { viewValue: '2', value: 'Type 2' },
    { viewValue: '3', value: 'Type 3' },
    { viewValue: '4', value: 'Type 4' },
    { viewValue: '5', value: 'Type 5' },
    { viewValue: '6', value: 'Type 6' },
    { viewValue: '7', value: 'Type 7' },
    { viewValue: '8', value: 'Type 8' },
    { viewValue: '9', value: 'Type 9' },
    { viewValue: '10', value: 'Type 10' },
    { viewValue: '11', value: 'Type 11' },
    { viewValue: '12', value: 'Type 12' },
    { viewValue: '13', value: 'Type 13' },
    { viewValue: '14', value: 'Type 14' },
    { viewValue: '15', value: 'Type 15' },
    { viewValue: '16', value: 'Type 16' },
    { viewValue: '17', value: 'Type 17' },
    { viewValue: '18', value: 'Type 18' },
    { viewValue: '19', value: 'Type 19' },
    { viewValue: '20', value: 'Type 20' },
    { viewValue: '21', value: 'Type 21' },
    { viewValue: '22', value: 'Type 22' },
    { viewValue: '23', value: 'Type 23' },
    { viewValue: '24', value: 'Type 24' },
    { viewValue: '25', value: 'Type 25' },
    { viewValue: '26', value: 'Type 26' },
    { viewValue: '27', value: 'Type 27' },
    { viewValue: '28', value: 'Type 28' },
    { viewValue: '29', value: 'Type 29' },
    { viewValue: '30', value: 'Type 30' },
    { viewValue: '31', value: 'Type 31' },
    { viewValue: '32', value: 'Type 32' },
    { viewValue: '33', value: 'Type 33' },
    { viewValue: '34', value: 'Type 34' },
    { viewValue: '35', value: 'Type 35' },
    { viewValue: '36', value: 'Type 36' },
    { viewValue: '37', value: 'Type 37' },
    { viewValue: '38', value: 'Type 38' },
  ];

  partner_type: any = [
    { viewValue: '1', value: 'Type 1' },
    { viewValue: '2', value: 'Type 2' },
    { viewValue: '3', value: 'Type 3' },
    { viewValue: '4', value: 'Type 4' },
  ];
  Image_icon_type: any = [
    { viewValue: 'Yes', value: '0' },
    { viewValue: 'No', value: '1' },
  ];
  whitethemetypes: any = [
    { viewValue: 'Yes', value: '0' },
    { viewValue: 'No', value: '1' },
  ];


  ShowAnimation: any = [
    { "value": "fadeInRightShorter", "viewValue": "Fade In Right Shorter" },
    { "value": "fadeInLeftShorter", "viewValue": "Fade In Left Shorter" },
    { "value": "blurIn", "viewValue": "Blur In" },
    { "value": "fadeIn", "viewValue": "Fade In" },
    { "value": "fadeInRight", "viewValue": "Fade In Right" },
    { "value": "fadeInLeft", "viewValue": "Fade In Left" },
    { "value": "fadeInUpShorter", "viewValue": "Fade In Up Shorter" },
    { "value": "fadeInDownShorter", "viewValue": "Fade In Down Shorter" },
    { "value": "scrolldown", "viewValue": "Scroll Down Animation" },
    { "value": "parallax", "viewValue": "Parallax Effect Animation" },
    { "value": "flip3D", "viewValue": "Flip 3D Animation" },
    { "value": "floating", "viewValue": "Floating Animation" },
    { "value": "morphing", "viewValue": "Morphing Animation" },
    { "value": "SlideInLeftlue", "viewValue": "Slide in Left Animation" },
    { "value": "none", "viewValue": "None" },

  ]

  ShowAnimation1: any = [
    { "value": "fadeInRightShorter", "viewValue": "Fade In Right Shorter" },
    { "value": "fadeInLeftShorter", "viewValue": "Fade In Left Shorter" },
    { "value": "blurIn", "viewValue": "Blur In" },
    { "value": "fadeIn", "viewValue": "Fade In" },
    { "value": "fadeInRight", "viewValue": "Fade In Right" },
    { "value": "fadeInLeft", "viewValue": "Fade In Left" },
    { "value": "fadeInUpShorter", "viewValue": "Fade In Up Shorter" },
    { "value": "fadeInDownShorter", "viewValue": "Fade In Down Shorter" },
  ]

  public sortings = [
    { value: 'price,DESC', viewValue: 'Price - High to Low' },
    { value: 'price,ASC', viewValue: 'Price - Low to High' },
    { value: 'createdDate,DESC', viewValue: 'Newest First' },
  ];
  public sortings1 = [
    { value: "price,DESC", viewValue: 'Price - High to Low' },
    { value: "price,ASC", viewValue: 'Price - Low to High' },
    { value: "createdDate,DESC", viewValue: 'Newest First' },
  ];

  public setposition = [
    { value: "1", viewValue: 'top-left' },
    { value: "2", viewValue: 'top-right' },
    { value: "3", viewValue: 'centered' },
    { value: "4", viewValue: 'bottom-left' },
    { value: "5", viewValue: 'bottom-right' },
  ];

  public setposition1 = [
    { value: "1", viewValue: 'bottom-left' },
    { value: "2", viewValue: 'bottom-right' },
    { value: "3", viewValue: 'centered' },
    { value: "4", viewValue: 'top-left' },
    { value: "5", viewValue: 'top-right' },
  ];

  public viewposition = [
    { value: "1", viewValue: 'right' },
    { value: "2", viewValue: 'left' },
    { value: "3", viewValue: 'top' },
    { value: "4", viewValue: 'bottom' },
  ];

  public tableType = [
    { value: "1", viewValue: 'Type - 1' },
    { value: "2", viewValue: 'Type - 2' },
    { value: "3", viewValue: 'Type - 3' },
    { value: "4", viewValue: 'Type - 4' },
    { value: "5", viewValue: 'Type - 5' },
    { value: "6", viewValue: 'Type - 6' },
    { value: "7", viewValue: 'Type - 7' },
    { value: "8", viewValue: 'Type - 8' },
    { value: "9", viewValue: 'Type - 9' },
    { value: "10", viewValue: 'Type - 10' },
    { value: "11", viewValue: 'Type - 11' },
    { value: "12", viewValue: 'Type - 12' },
    { value: "13", viewValue: 'Type - 13' },
    { value: "14", viewValue: 'Type - 14' },
    { value: "15", viewValue: 'Type - 15' },
    { value: "16", viewValue: 'Type - 16' },
  ];


  submittype: any = [
    { "value": "1", "viewValue": "Form Submission" },
    { "value": "0", "viewValue": "Vendor Submission" },
    { "value": "2", "viewValue": "Calculation Submission" },
    { "value": "3", "viewValue": "Register" },
    { "value": "4", "viewValue": "Form Submission New" },
  ]

  enablePayment: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "0", "viewValue": "No" },
  ]
  enablePrivacypolicy: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "0", "viewValue": "No" },
  ]
  enablebroucherbutton: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "0", "viewValue": "No" },
  ]


  Formtype: any = [
    { "value": "0", "viewValue": "Default" },
    { "value": "1", "viewValue": "Step Form" },
    { "value": "2", "viewValue": "Stepper Form" },
    { "value": "3", "viewValue": "Calculation" },
  ]


  addNew() {
    if (this._form.valid) {
      (<UntypedFormArray>this._form.get('conditions')).push(this.createLayoutForm());

      this.scrollToBottomPosition();
    } else {
      this._form.markAllAsTouched();
    }
  }

  addNew1(e: string, i: number) {
    if (this._form.valid) {
      const newFormGroup = this.createLayoutForm();

      (<UntypedFormArray>this._form.get('conditions')).push(newFormGroup);

      newFormGroup.patchValue({ type: e });

      this.scrollToBottomPosition();
      this.onChangeImageNew(e, i);
    } else {
      this._form.markAllAsTouched();
    }
  }


  public serverPath = environment.commonImageApi + '/home/';

  removeOption(i) {
    let value = this._form.value.conditions[i];

    if (this._form.value.conditions[i].layoutConfigId != 0) {
      this.removedList.push(value);

      this.homePageService.delete(this.removedList).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            //this.getCartItems();
            (<UntypedFormArray>this._form.get('conditions')).removeAt(i);
            this.snackBar.open(response['status_message'], '×', {
              panelClass: 'success',
              verticalPosition: 'bottom',
              duration: 500,
            });
            this.getValue();

          } else {
            this.snackBar.open(response['status_message'], '×', {
              panelClass: 'error',
              verticalPosition: 'bottom',
              duration: 500,
            });
          }
        },
        (err) => { }
      );
    } else {
      (<UntypedFormArray>this._form.get('conditions')).removeAt(i);
    }

    if ((value.type == 'image')) {
      this.deleteImage(value.images, 'image');
    } else if ((value.type == 'banner')) {
      this.deleteImage(value.images, 'banner');
    }
  }


  deleteImage(i, type) {
    i.forEach((element) => {
      let smallImage = null;
      if (type == 'image') {
        smallImage = '/home/' + element.img;
      } else if (type == 'banner') {

        smallImage = '/commonSlider/' + element.img;
      }

      else {
        smallImage = "/commonSlider/" + element.img;
      }

      this.imagesToRemoved.push(smallImage);
    });

    this.productService.deleteImage(this.imagesToRemoved).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 500,
          });
          this.text = 'Save';
        } else {
          this.text = 'Save';
          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 500,
          });
        }
      },
      (err) => {
        this.text = 'Save';
      }
    );
  }

  CategoryTypeList: any;
  filteredCategoryTypeList: any;

  CategoryList: any;
  getCategoryList() {
    this.catalogPriceRulesService.fetchAlldropdownValueForRule().subscribe(
      (res) => {
        this.CategoryList = res['category'];
        let object = [{
          breadCrumpPath: "Spices",
          categoryId: 0,
          categoryName: "None",
          childCount: 2,
          description: "Spices",
          image: null,
          includeInMenu: "1",
          isActive: "0",
          mega: "false",
          metaDescription: "Spices",
          parentId: "2",
          path: "1062",
          pathValue: "1/2/1062",
          position: 0,
          subcategories: [],
          type: "PARENT"
        },
        ]



        this.CategoryList = [...this.CategoryList, ...object];
        this.CategoryTypeList = this.CategoryList;
        this.filteredCategoryTypeList = this.CategoryTypeList;
      },
      (error) => { }
    );
  }

  public categoryFilterControl: UntypedFormControl = new UntypedFormControl();
  categoryYFilter() {
    this.categoryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.categoryFilter();
      });
  }

  protected categoryFilter() {
    if (!this.CategoryTypeList) {
      return;
    }
    let search = this.categoryFilterControl.value;
    if (!search) {
      this.filteredCategoryTypeList = this.CategoryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredCategoryTypeList = this.CategoryTypeList.filter(
      (category) => category['categoryName'].toLowerCase().indexOf(search) > -1
    );
  }

  getAllCategory() {
    this.filteredCategoryTypeList = this.CategoryTypeList;
  }

  getResult(event, i, index) {

    // this.firstFormGroup.value.image = this.mediaGallery.concat(event.productEntityMediaGallery);

    this._form.value.conditions[i].images[index].img =
      event.productEntityMediaGallery[0].fileName;


    this._form.patchValue(this._form.value);

    this.snackBar.open('Image Uploaded Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });
  }



  update(event, index) {
    this._form.value.conditions[event].images[index].img = '';
    this._form.patchValue(this._form.value);
  }




  openEditorText(value, index, formContronlName) {



    if (window.innerWidth > 768) {

      const dialogRef = this.dialog.open(TextEditorComponent, {
        width: '900px',
        disableClose: true,
        data: value
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this._form.value.conditions[index][formContronlName] = result['data']
          this._form.patchValue(this._form.value)
        }


      });

    }
    else {
      const dialogRef = this.dialog.open(TextEditorComponent, {
        minWidth: '100vw', height: '100vh',
        disableClose: true,
        data: value
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this._form.value.conditions[index].customField1 = result['data']
          this._form.patchValue(this._form.value)
        }

      });

    }
  }

  openEditorTextForImageArray(value, index, formContronlName, secondIndex) {

    if (window.innerWidth > 768) {

      const dialogRef = this.dialog.open(TextEditorComponent, {
        width: '900px',
        disableClose: true,
        data: value
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {


          this._form.value.conditions[index].images[secondIndex][formContronlName] = result['data']

          this._form.patchValue(this._form.value)
        }


      });

    }
    else {
      const dialogRef = this.dialog.open(TextEditorComponent, {
        minWidth: '100vw', height: '100vh',
        disableClose: true,
        data: value
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {


          this._form.value.conditions[index].images[secondIndex][formContronlName] = result['data']

          this._form.patchValue(this._form.value)
        }

      });

    }
  }



  openEditorTextForSubChildArray(value, index, formContronlName, thirdIndex, secondIndex) {

    if (window.innerWidth > 768) {

      const dialogRef = this.dialog.open(TextEditorComponent, {
        width: '900px',
        disableClose: true,
        data: value
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {


          this._form.value.conditions[index].images[secondIndex]['subChild'][thirdIndex][formContronlName] = result['data']

          this._form.patchValue(this._form.value)
        }


      });

    }
    else {
      const dialogRef = this.dialog.open(TextEditorComponent, {
        minWidth: '100vw', height: '100vh',
        disableClose: true,
        data: value
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {


          this._form.value.conditions[index].images[secondIndex][formContronlName] = result['data']

          this._form.patchValue(this._form.value)
        }

      });

    }
  }


  navigation: any = [
    { viewValue: 'Link', value: 1 },
    { viewValue: 'Category', value: 0 },
    { viewValue: 'Form', value: 2 },
    { viewValue: 'Scroll Top', value: 3 },
  ];

  navigationType: any = [
    { viewValue: 'Link', value: 0 },
    { viewValue: 'Form', value: 1 },
    { viewValue: 'Scroll Top', value: 2 },
  ];



  navigation1: any = [
    { viewValue: 'Link', value: "1" },
    { viewValue: 'Category', value: "0" },

  ];

  booleanFieldString: any = [
    { "value": "0", "viewValue": "Type-1" },
    { "value": "1", "viewValue": "Type-2" },
  ]


  displayViewMore: any = [
    { "value": "0", "viewValue": "Type-1" },
    { "value": "1", "viewValue": "Type-2" },
    { "value": "2", "viewValue": "Type-3" },
    { "value": "3", "viewValue": "Type-4" },
  ]

  displayTitle: any = [
    { "value": "0", "viewValue": "Yes" },
    { "value": "1", "viewValue": "No" },
  ]

  displaysocialmedia: any = [
    { "value": "0", "viewValue": "Yes" },
    { "value": "1", "viewValue": "No" },
  ]


  playstore: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "0", "viewValue": "No" },
  ]


  Appstore: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "0", "viewValue": "No" },
  ]

  displaysubscribe: any = [
    { "value": "0", "viewValue": "Yes" },
    { "value": "1", "viewValue": "No" },
  ]

  displaycontact: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "0", "viewValue": "No" },
  ]

  SubscriberButtontype: any = [
    { "value": "0", "viewValue": "Type-1" },
    { "value": "1", "viewValue": "Type-2" },
  ]

  tablayout: any = [
    { viewValue: "Category", value: "Category" },
    { viewValue: "Image", value: "Image" },
    { viewValue: "Product Scope", value: "ProductScope" },
    { viewValue: "Text With Image", value: "TextWithImage" },
    { viewValue: "Text", value: "Text" },
    { viewValue: "Images with Title", value: "Imagewithtitle" },

  ];

  Partnerslayout: any = [
    { viewValue: "Product Scope", value: "ProductScope" },
    { viewValue: "Category", value: "Category" },
  ];


  Brandslayout: any = [
    { viewValue: "Image", value: "Image" },
  ];
  ImageNavType: any = [
    { "value": "0", "viewValue": "Type-1" },
    { "value": "1", "viewValue": "Type-2" },
  ];

  animateType: any = [
    { "value": "animate__fadeInUp", "viewValue": "animate__fadeInUp" },
    { "value": "animate__fadeInDown", "viewValue": "animate__fadeInDown" },
    { "value": "animate__zoomIn", "viewValue": "animate__zoomIn" },
  ]

  animeType: any = [
    { "value": "rotate-image", "viewValue": "Type 1" },
    { "value": "rotate-image2", "viewValue": "Type 2" },
    { "value": "none", "viewValue": "Type 3" },
  ]


  tablayout1: any = [
    { viewValue: "Category", value: "Category" },
    { viewValue: "Product Scope", value: "ProductScope" },
    { viewValue: "Image", value: "Image" },
  ];

  footertypes: any = [
    { viewValue: "Text With Icon", value: "textwithicon" },
    { viewValue: "Text ", value: "text" },
    { viewValue: "Images", value: "image" },
    { viewValue: "Text With Image", value: "textwithimage" },
  ];

  displayMode: any = [
    { viewValue: 'All', value: 1 },
    { viewValue: 'Only in Mobile', value: 2 },
    { viewValue: 'Only in Tab', value: 3 },
    { viewValue: 'Only in Web', value: 4 },
  ];

  displayMode1: any = [
    { viewValue: 'All', value: "1" },
    { viewValue: 'Only in Mobile', value: "2" },
    { viewValue: 'Only in Tab', value: "3" },
    { viewValue: 'Only in Web', value: "4" },
  ];


  dataType: any = [
    { viewValue: 'Image', value: 1 },
    { viewValue: 'Youtube-Video-Id', value: 2 },
    { viewValue: 'Video', value: 3 },
    { viewValue: 'Rotate Content', value: 4 },
    { viewValue: 'Image Card', value: 5 },
    { viewValue: 'Look Back ', value: 6 },
    { viewValue: 'Image Text ', value: 7 },
    { viewValue: 'Image Icon Text', value: 8 },
    { viewValue: 'Icon Text', value: 9 },
    { viewValue: 'Image Over Content', value: 10 },
    { viewValue: 'Price Plan', value: 11 },
    { viewValue: 'Rotate Content With Table', value: 12 },
    { viewValue: 'Video with content', value: 13 },
  ];

  textWithImageType: any = [
    { viewValue: 'Image', value: 1 },
    { viewValue: 'VideoType', value: 3 },
  ];

  textWithImage: any = [
    { viewValue: 'Image', value: 1 },
    { viewValue: 'Youtube-Video-Id', value: 2 },
  ];



  alignMent: any = [
    { viewValue: 'Center', value: 0 },
    { viewValue: 'Left', value: 1 },
  ];

  sliderAnimation: any = [
    { viewValue: 'Enable', value: 1 },
    { viewValue: 'Disable', value: 0 },
  ];

  TitleAlignMent: any = [
    { viewValue: 'Center', value: "Center" },
    { viewValue: 'Left', value: "Left" },
    { viewValue: 'scroll', value: "scroll" },
  ];
  VideoTitleAlignMent: any = [

    { viewValue: 'Left', value: "Left" },
    { viewValue: 'Center', value: "Center" },

  ];

  alignMent1: any = [
    { viewValue: 'Right', value: "1" },
    { viewValue: 'Left', value: "0" },
  ];



  Stepalignment: any = [
    { viewValue: 'End', value: "End" },
    { viewValue: 'Start', value: "Start" },
  ];

  boolean: any = [
    { viewValue: 'True', value: "1" },
    { viewValue: 'False', value: "2" },
  ];

  boolean1: any = [
    { viewValue: 'False', value: 0 },
    { viewValue: 'True', value: 1 },
  ];

  subcontent: any = [
    { viewValue: 'True', value: "1" },
    { viewValue: 'False', value: "0" },
  ];


  layoutType: any = [
    { viewValue: 'type1', value: 'Type 1' },
    { viewValue: 'type2', value: 'Type 2' },
    { viewValue: 'type3', value: 'Type 3' },
    { viewValue: 'type4', value: 'Type 4' },
    { viewValue: 'type5', value: 'Type 5' },
    { viewValue: 'type6', value: 'Type 6' },
    { viewValue: 'type7', value: 'Type 7' },
    { viewValue: 'type8', value: 'Type 8' },
    { viewValue: 'type9', value: 'Type 9' },
    { viewValue: 'type10', value: 'Type 10' },
    { viewValue: 'type11', value: 'Type 11' },
    { viewValue: 'type12', value: 'Type 12' },
    { viewValue: 'type13', value: 'Type 13' },
    { viewValue: 'type14', value: 'Type 14' },
    { viewValue: 'type15', value: 'Type 15' },
    { viewValue: 'type16', value: 'Type 16' },
    { viewValue: 'type17', value: 'Type 17' },
    // { viewValue: 'type18', value: 'Type 18' },
    // { viewValue: 'type19', value: 'Type 19' },
    // { viewValue: 'type20', value: 'Type 20' },
    // { viewValue: 'type21', value: 'Type 21' },
  ];


  videotype: any = [
    { "value": 0, "viewValue": "Controls" },
    { "value": 1, "viewValue": "Autoplay" },
    { "value": 2, "viewValue": "Autoplay Muted" },
  ]

  boxshadow: any = [
    { "value": 0, "viewValue": "No" },
    { "value": 1, "viewValue": "Yes" },
  ]

  booleanVariable: any = [
    { "value": 0, "viewValue": "Yes" },
    { "value": 1, "viewValue": "No" },

  ]


  displaylogin: any = [
    { "value": 0, "viewValue": "Yes" },
    { "value": 1, "viewValue": "No" },

  ]

  Title_view: any = [
    { viewValue: '1', value: 'left' },
    { viewValue: '2', value: 'center' },
    { viewValue: '3', value: 'right' },
  ];

  textwithtexttype: any = [
    { viewValue: '1', value: 'Type1' },
    { viewValue: '2', value: 'Type2' },
  ];


  booleanVariable1: any = [
    { "value": "0", "viewValue": "Yes" },
    { "value": "1", "viewValue": "No" },

  ]

  layoutType1: any = [
    { viewValue: 'type1', value: 'Type 1' },
    { viewValue: 'type2', value: 'Type 2' },
    { viewValue: 'type3', value: 'Type 3' },
    { viewValue: 'type4', value: 'Type 4' },
    { viewValue: 'type5', value: 'Type 5' },
    { viewValue: 'type6', value: 'Type 6' },
    { viewValue: 'type7', value: 'Type 7' },
    { viewValue: 'type8', value: 'Type 8' },
    { viewValue: 'type9', value: 'Type 9' },
    { viewValue: 'type10', value: 'Type 10' },
    { viewValue: 'type11', value: 'Type 11' },
    { viewValue: 'type12', value: 'Type 12' },
  ];

  comparetype: any = [
    { viewValue: 'type1', value: 'Type 1' },
    { viewValue: 'type2', value: 'Type 2' },
  ];


  layoutType3: any = [
    { viewValue: 'type1', value: 'Type 1' },
    { viewValue: 'type2', value: 'Type 2' },
    { viewValue: 'type3', value: 'Type 3' },
    { viewValue: 'type4', value: 'Type 4' },
    { viewValue: 'type5', value: 'Type 5' },
    { viewValue: 'type6', value: 'Type 6' },
    { viewValue: 'type7', value: 'Type 7' },
    { viewValue: 'type8', value: 'Type 8' },
  ];
  layoutType4: any = [
    { viewValue: 'type1', value: 'Type 1' },
    { viewValue: 'type2', value: 'Type 2' },
    { viewValue: 'type3', value: 'Type 3' },
    { viewValue: 'type4', value: 'Type 4' },
    { viewValue: 'type5', value: 'Type 5' },
    { viewValue: 'type8', value: 'Type 8' },
  ];
  layoutType5: any = [
    { viewValue: 'type1', value: 'Type 1' },
    { viewValue: 'type2', value: 'Type 2' },
    { viewValue: 'type3', value: 'Type 3' },
    { viewValue: 'type4', value: 'Type 4' }
  ];

  public bannerServerPath = environment.commonImageApi + '/commonSlider/';



  getResultBanner(event, i) {

    // this.firstFormGroup.value.image = this.mediaGallery.concat(event.productEntityMediaGallery);

    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(i);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;



    event.productEntityMediaGallery.forEach(element => {

      value.push(this._formBuilder.group({
        valueId: new UntypedFormControl(0),
        img: new UntypedFormControl(element['fileName']),
        catId: new UntypedFormControl(0),
        navigation: new UntypedFormControl(0),
        customField22: new UntypedFormControl(1),
        customField1: [''],
        customField2: [''],
        customField3: [''],
        customField4: [''],
        customField5: [''],
        customField24: [''],
        customField10: [''],
        customField11: [''],
        customField8: [''],
        customField12: [''],
        customField28: [''],
        customField29: [''],
        customField30: [''],
        customField31: [''],
        customField32: [''],
        customField33: [''],
        customField34: [''],
        customField35: [''],
        customField36: [''],
        customField37: [''],
        customField38: [''],
        customField39: [''],
        customField40: [''],
        customField15: [''],
        customField16: [''],
        customField20: [''],
        customField21: [''],
        customField9: [''],
        customField6: [''],
        customField7: [''],
        altImage: [''],
        type: new UntypedFormControl(0),
      })

      )
    });

    this.snackBar.open('Image Uploaded Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });

  }


  getResultBannerChild(event, i, j) {

    // this.firstFormGroup.value.image = this.mediaGallery.concat(event.productEntityMediaGallery);

    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(i);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    var subItem = value.at(j);
    let valueSub = (<UntypedFormArray>subItem.get('subChild')) as UntypedFormArray;


    event.productEntityMediaGallery.forEach(element => {

      valueSub.push(this._formBuilder.group({
        valueId: new UntypedFormControl(0),
        customField6: new UntypedFormControl(element['fileName']),
        catId: new UntypedFormControl(0),
        navigation: new UntypedFormControl(0),
        customField22: new UntypedFormControl(1),
        customField1: [''],
        customField2: [''],
        customField3: [''],
        customField4: [''],
        customField5: [''],
        customField29: [''],
        customField30: [''],
        customField31: [''],
        customField32: [''],
        customField33: [''],
        customField34: [''],
        customField35: [''],
        customField36: [''],
        customField37: [''],
        customField38: [''],
        customField39: [''],
        customField40: [''],
        customField13: [''],
        customField7: [''],
        customField8: [''],
        customField9: [''],
        customField10: [''],
        customField11: [''],
        customField12: [''],
        type: new UntypedFormControl(0),
      })

      )
    });

    this.snackBar.open('Image Uploaded Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });

  }



  updateBanner(event, index, secondIndex) {
    this.deleteImageBanner(event);
    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(index);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    value.removeAt(secondIndex);
  }

  updateBannerChild(event, index, secondIndex, thirdIndex) {
    this.deleteImageBanner(event);
    this.removeArray(index, secondIndex, thirdIndex);

  }
  removeArray(index: any, secondIndex: any, thirdIndex: any) {
    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(index);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    var addImagesArraySubitem = value.at(secondIndex);
    let valueSub = (<UntypedFormArray>addImagesArraySubitem.get('subChild')) as UntypedFormArray;
    valueSub.removeAt(thirdIndex);
  }



  deleteText(index, secondIndex) {

    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(index);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    value.removeAt(secondIndex);
  }

  deleteLayoutSub(index, secondIndex) {
    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(index);
    let value = (<UntypedFormArray>item.get('layoutSub')) as UntypedFormArray;
    value.removeAt(secondIndex);
  }


  deleteImageBanner(i) {

    let smallImage = "/commonSlider/" + i;
    this.imagesToRemoved.push(smallImage);

    this.productService.deleteImage(this.imagesToRemoved).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save"

        }
        else {


          this.text = "Save"
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {

      });

  }

  getResultts(event, i, value) {

    // this.firstFormGroup.value.image = this.mediaGallery.concat(event.productEntityMediaGallery);

    this._form.value.conditions[i][value] =
      event.productEntityMediaGallery[0].fileName;


    this._form.patchValue(this._form.value);

    this.snackBar.open('Image Uploaded Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });
  }


  getResultArray(event, i, value, j) {

    // this.firstFormGroup.value.image = this.mediaGallery.concat(event.productEntityMediaGallery);

    this._form.value.conditions[i]['images'][j][value] =
      event.productEntityMediaGallery[0].fileName;


    this._form.patchValue(this._form.value);

    this.snackBar.open('Image Uploaded Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });
  }

  getResultArraySubChild(event, i, value, j, k) {



    this._form.value.conditions[i]['images'][j]['subChild'][k][value] =
      event.productEntityMediaGallery[0].fileName;


    this._form.patchValue(this._form.value);

    this.snackBar.open('Image Uploaded Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });
  }



  updates(event, index) {
    this._form.value.conditions[event].images[index].img = '';
    this._form.patchValue(this._form.value);
  }

  updatesIMage(event, i, value) {
    this._form.value.conditions[i][value] = '';
    this._form.patchValue(this._form.value);
  }

  updatesImageArray(event, i, value, j) {
    this._form.value.conditions[i]['images'][j][value] = '';
    this._form.patchValue(this._form.value);
  }

  updatesImageArraySubschild(event, i, value, j, z) {
    this._form.value.conditions[i]['images'][j]['subChild'][z][value] = '';
    this._form.patchValue(this._form.value);
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.openDrawer()
  }

  doSomething(event, i, j) {

    if (event.value == 0) {


      this._form.controls.conditions['controls'][i]['controls'][j].reset()



    }

  }

  doSomething1(event, i, j, k) {


    if (event.value == 0) {


      this._form.controls.conditions['controls'][i]['controls']['images']['controls'][j]['controls'][k].reset()



    }

    this._form.controls.conditions['controls'][i]['controls']['images']['controls'][j]['controls'][k] = 0;

    this._form.patchValue(this._form.value)

  }



  productScopeTypeList: any;
  filteredproductScopeTypeList: any;

  productScopeList: any;
  getproductScopeList() {
    this.customProductScopeService.getAllCustomerProductScopeDropDown().subscribe(
      (res) => {
        this.productScopeList = res;
        this.productScopeTypeList = this.productScopeList;
        this.filteredproductScopeTypeList = this.productScopeTypeList;
      },
      (error) => { }
    );
  }

  public productScopeFilterControl: UntypedFormControl = new UntypedFormControl();
  productScopeYFilter() {
    this.productScopeFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.productScopeFilter();
      });
  }

  protected productScopeFilter() {
    if (!this.productScopeTypeList) {
      return;
    }
    let search = this.productScopeFilterControl.value;
    if (!search) {
      this.filteredproductScopeTypeList = this.productScopeTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredproductScopeTypeList = this.productScopeTypeList.filter(
      (productScope) => productScope['type'].toLowerCase().indexOf(search) > -1
    );
  }

  getAllproductScope() {
    this.filteredproductScopeTypeList = this.productScopeTypeList;
  }

  getproductScope() {
    this.getproductScopeList();
    this.productScopeYFilter();
    this.getAllproductScope();
  }


  //   setProductScope(event, i,j) {

  //     if (event.isUserInput != false) {

  //       this.firstFormGroup.value.address[j].region=i.defaultName;
  //       this.firstFormGroup.value.address[j].countryId=i.code;
  //       this.firstFormGroup.value.address[j].regionId=i.regionId;
  //  this.firstFormGroup.patchValue(this.firstFormGroup.value)
  //     }
  //   }


  setProductScopeChild(event, object, value, i, y) {

    if (event.isUserInput != false) {

      this._form.value.conditions[i]['images'][y][value] =
        object.productId;


      this._form.patchValue(this._form.value);
    }

  }

  setProductScopeLayoutSub(event, object, value, i, y) {

    if (event.isUserInput != false) {

      this._form.value.conditions[i]['layoutSub'][y][value] =
        object.productId;


      this._form.patchValue(this._form.value);
    }

  }

  setProductScopeImageLayoutSub(event, object, value, i, y, z) {

    if (event.isUserInput != false) {

      this._form.value.conditions[i]['images'][y]['subChild'][z][value] =
        object.productId;


      this._form.patchValue(this._form.value);
    }

  }

  setProductScope(event, object, value, i) {

    if (event.isUserInput != false) {

      this._form.value.conditions[i][value] =
        object.productId;


      this._form.patchValue(this._form.value);
    }

  }

  setProductScope1(event, object, value, i, j) {

    if (event.isUserInput != false) {

      this._form.value.conditions[i][value] =
        object.productId;


      this._form.patchValue(this._form.value);
    }

  }


  customScopeTypeList: any;
  filteredcustomScopeTypeList: any;

  customScopeList: any;
  getcustomScopeList() {
    this.reviewandratingService.getAllCustomerReviewDropDown().subscribe(
      (res) => {
        this.customScopeList = res;
        this.customScopeTypeList = this.customScopeList;
        this.filteredcustomScopeTypeList = this.customScopeTypeList;
      },
      (error) => { }
    );
  }

  public customScopeFilterControl: UntypedFormControl = new UntypedFormControl();
  customScopeYFilter() {
    this.customScopeFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.customScopeFilter();
      });
  }

  protected customScopeFilter() {
    if (!this.customScopeTypeList) {
      return;
    }
    let search = this.customScopeFilterControl.value;
    if (!search) {
      this.filteredcustomScopeTypeList = this.customScopeTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredcustomScopeTypeList = this.customScopeTypeList.filter(
      (productScope) => productScope['productScopeName'].toLowerCase().indexOf(search) > -1
    );
  }

  getAllcustomScope() {
    this.filteredcustomScopeTypeList = this.customScopeTypeList;
  }

  getcustomScope() {
    this.getcustomScopeList();
    this.customScopeYFilter();
    this.getAllcustomScope();
  }


  //   setProductScope(event, i,j) {

  //     if (event.isUserInput != false) {

  //       this.firstFormGroup.value.address[j].region=i.defaultName;
  //       this.firstFormGroup.value.address[j].countryId=i.code;
  //       this.firstFormGroup.value.address[j].regionId=i.regionId;
  //  this.firstFormGroup.patchValue(this.firstFormGroup.value)
  //     }
  //   }

  setCustomScope(event, object, value, i) {

    if (event.isUserInput != false) {

      this._form.value.conditions[i][value] =
        object.productId;


      this._form.patchValue(this._form.value);
    }

  }


  //warehouse
  productList: any = [];
  productTypeList: any = [];
  filteredProductTypeList: any = [];
  productControl: UntypedFormControl = new UntypedFormControl();
  productFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllProductList() {

    this.productsService.getAllProductDropDown().subscribe(
      data => {
        this.productList = data;

        this.productTypeList = data;
        this.filteredProductTypeList = this.productTypeList;

      }
    )

    this.productYFilter();
    this.getAllProduct();
  }


  getAllProduct() {
    this.filteredProductTypeList = this.productTypeList;
  }

  productYFilter() {
    this.productFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.productFilter();
      });
  }

  protected productFilter() {
    if (!this.productTypeList) {
      return;
    }
    // get the search keyword
    let search = this.productFilterControl.value;
    if (!search) {
      this.filteredProductTypeList = this.productTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredProductTypeList = this.productTypeList.filter(Product => Product['name'].toLowerCase().indexOf(search) > -1)
  }


  //auto search



  public onDelete(event: IDelete) {
    //console.log(event);
  }

  public onDetected(event: IDetect) {
    if (event.type == 'keyboard' && event?.event.key == 'Enter') {
      this.filterOption(event, 'scanner');
    } else if (event.type == 'scanner') {
      this.filterOption(event, event.type);
    } else {
      this.filterOption(event, 'keyup');
    }
  }


  //search
  @ViewChild(MatAutocompleteTrigger, { static: true })
  autocomplete: MatAutocompleteTrigger;
  focused: boolean;
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'entityId' + ',' + Constant.Dsc;
  filteredOptions: any;


  filterOption(event, type) {
    let searchTerm = null;
    let value: any = 1;
    if (event.type == 'keyboard' && event?.event.key == 'Enter') {
      this.page = 0;
      this.size = 1;
      searchTerm =
        'name:' +
        '*' +
        event.value.trim() +
        '*' +
        "' AND isInStock:" +
        '*' +
        value +
        '*' +
        "' ";
    } else if (type == 'scanner12') {
      this.page = 0;
      this.size = 1;
      searchTerm =
        'sku:' +
        '*' +
        event.trim() +
        '*' +
        "' AND isInStock:" +
        '*' +
        value +
        '*' +
        "' ";
    } else if (type == 'scanner') {
      this.page = 0;
      this.size = 1;
      searchTerm =
        'sku:' +
        '*' +
        event.value.trim() +
        '*' +
        "' AND isInStock:" +
        '*' +
        value +
        '*' +
        "' ";
    } else {
      this.page = 0;
      this.size = 10;
      value = 1;
      searchTerm =
        "name:" +
        '*' +
        event.value +
        '*' +
        " OR sku:" +
        '*' +
        event.value +
        '*';
    }

    this.sortParam = 'price,DESC';
    this.productService
      .getProductBySearch(searchTerm, this.page, this.size, this.sortParam)
      .subscribe((res) => {
        let product = '';
        if (type == 'scanner') {
          product = res['content'][0];
        } else if (type == 'scanner12') {
          product = res['content'][0];
        } else {
          this.filteredOptions = res['content'];
        }

        this.empty = res['empty'];

        if (!this.empty && type == 'scanner') {
          // this.addToCartProduct(
          //   product,
          //   type,
          //   product['minSaleQty'] == 0 ? 1 : product['minSaleQty']
          // );
        } else if (this.empty && type == 'scanner') {

          // this.snackBar.open(
          //   'No Products added, add some products first',
          //   '×',
          //   {
          //     panelClass: 'error',
          //     verticalPosition: 'bottom',
          //     duration: 500,
          //   }
          // );
        } else if (!this.empty && type == 'scanner12') {
          // this.addToCartProduct(
          //   product,
          //   type,
          //   product['minSaleQty'] == 0 ? 1 : product['minSaleQty']
          // );
        } else if (this.empty && type == 'scanner12') {

          this.snackBar.open(
            'No Products added, add some products first',
            '×',
            {
              panelClass: 'error',
              verticalPosition: 'bottom',
              duration: 500,
            }
          );
        }
      });
  }

  onKeydown(event) {
    this.filterOption(event, event.type);
  }

  getProducts(product, i, j, k) {
    let object = JSON.stringify(product);
    this._form.value.conditions[i].images[j].subChild[k].customField11 = product.name;
    this._form.value.conditions[i].images[j].subChild[k].customField12 = object;
    this._form.value.conditions[i].images[j].subChild[k].customField13 = product.entityId;
    this._form.patchValue(this._form.value);
  }

  clearInput(i, j, k) {
    this._form.value.conditions[i].images[j].subChild[k].customField11 = '';
    this._form.value.conditions[i].images[j].subChild[k].customField12 = '';
    this._form.value.conditions[i].images[j].subChild[k].customField13 = 0;
    this._form.value.conditions[i].images[j].subChild[k].customField14 = '';
    this._form.patchValue(this._form.value);
  }


  openDropdown() {
    this.focused = true;
  }

  closeDropdown() {
    this.focused = false;
  }



  getImageUrl(url, height, heightMob, i, j) {

    if (height == '' || heightMob == '') {
      this.snackBar.open('Please Fill Out this Field Height & Mobile Height', 'X', {
        duration: 500,
        verticalPosition: 'bottom',
        panelClass: ['error'],
      });
    } else {

      this.opemImageDotPopup(url, i, j)


    }
  }


  dots: any = []
  @ViewChild('imageDot') imageDot: TemplateRef<any>;
  opemImageDotPopup(url, i, j) {

    this.dots = this._form.value.conditions[i].images[j].subChild;
    this.imageUrl = url;
    this.dotPrimaryIndex = i;
    this.dotSecondryIndex = j;
    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(this.imageDot, {
        disableClose: true,
        width: '900px',
      });

      dialogRef.afterClosed().subscribe((result) => {

        this.imageUrl = '';

      });
    }
    else {
      let dialogRef = this.dialog.open(this.imageDot, {
        minWidth: '100vw', height: '100vh',
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.imageUrl = '';

      });
    }

  }

  saveDot() {
    this.dialog.closeAll();
  }

  close() {
    this.dialog.closeAll();
  }

  setDots(event) {
    var imageContainer = document.getElementById('image-container');

    var x = (event.clientX - imageContainer.getBoundingClientRect().left) / imageContainer.clientWidth * 100;
    var y = (event.clientY - imageContainer.getBoundingClientRect().top) / imageContainer.clientHeight * 100;
    this.roundedleft = Math.round(x);
    this.roundedtop = Math.round(y);

    this.setValueForDots();

  }

  onChangeSubChild(event, i, j) {


    if (event.isUserInput != false) {
      this._form.value.conditions[i]['images'][j]['subChild'] = new UntypedFormArray([]).value;

      // Instead of patching the whole form value, you can directly set the value for the specific control.
      this._form.get(`conditions.${i}.images.${j}.subChild`).setValue(new UntypedFormArray([]).value);
    }


  }

  setValueForDots() {
    var arrayControl = this._form.get('conditions') as UntypedFormArray;
    var item = arrayControl.at(this.dotPrimaryIndex);
    let value = (<UntypedFormArray>item.get('images')) as UntypedFormArray;
    var subItem = value.at(this.dotSecondryIndex);
    let valueSub = (<UntypedFormArray>subItem.get('subChild')) as UntypedFormArray;
    let length = 0;
    if (valueSub == null) {
      length = 0;

    } else {
      length = valueSub.length == undefined ? 0 : valueSub.length;
    }

    valueSub.push(this._formBuilder.group({
      valueId: new UntypedFormControl(0),
      catId: new UntypedFormControl(0),
      navigation: new UntypedFormControl(0),
      customField22: new UntypedFormControl(1),
      customField1: [''],
      customField2: [''],
      customField3: this.roundedtop + '%',
      customField4: this.roundedleft + '%',
      customField5: length + 1,
      position: new UntypedFormControl(0),
      customField14: [''],
      customField11: [''],
      customField12: [''],
      customField13: [''],
    })

    )

    this.dots = this._form.value.conditions[this.dotPrimaryIndex].images[this.dotSecondryIndex].subChild;

    this.snackBar.open('Dot Added Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });

  }


  //contact form

  dynamicFormTypeList: any;
  filtereddynamicFormTypeList: any;

  public dynamicFormFilterControl: UntypedFormControl = new UntypedFormControl();

  dynamicFormList: any;
  getdynamicFormList() {
    this.dynamicFormGroupService.getAllDynmaicFormDropDown(1).subscribe(
      (res) => {
        this.dynamicFormList = res;
        this.dynamicFormTypeList = this.dynamicFormList;
        this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
      },
      (error) => { }
    );
  }

  dynmaicFormYFilter() {
    this.dynamicFormFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.dynamicFilter();
      });
  }

  protected dynamicFilter() {
    if (!this.dynamicFormTypeList) {
      return;
    }
    let search = this.dynamicFormFilterControl.value;
    if (!search) {
      this.filtereddynamicFormTypeList = this.dynamicFormTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filtereddynamicFormTypeList = this.dynamicFormTypeList.filter(
      (dynamicForm) => dynamicForm['name'].toLowerCase().indexOf(search) > -1
    );
  }

  getAlldynamicForm() {
    this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
  }

  getdynamicForm() {
    this.getdynamicFormList();
    this.dynmaicFormYFilter();
    this.getAlldynamicForm();
  }


  setDynamicForm(event, object, value, i) {

    if (event.isUserInput != false) {

      this._form.value.conditions[i][value] =
        object.formGroupId;


      this._form.patchValue(this._form.value);
    }

  }

  setDynamicFormarray(event, object, value, i, j) {

    if (event.isUserInput != false) {

      this._form.value.conditions[i]['images'][j][value] =
        object.formGroupId;


      this._form.patchValue(this._form.value);
    }

  }

  setDynamicFormarrayString(event, object, value, i, j) {

    if (event.isUserInput != false) {

      this._form.value.conditions[i]['images'][j][value] =
        object.formGroupId.toString();


      this._form.patchValue(this._form.value);
    }

  }


  disabled(value) {

    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  copy() {


    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CopyTemplateComponent, {
        width: '790px',
        disableClose: true,
        data: {
          value: this.value,
          type: this.type,
          title: this.title,
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          // this.getData();

        }



      });

    }
    else {
      let dialogRef = this.dialog.open(CopyTemplateComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          value: this.value,
          type: this.type,
          title: this.title
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.getData();
        }


      });
    }


  }

  useTemplate() {

    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(EcommercetemplateComponent, {
        width: '790px',
        disableClose: true,
        data: {
          value: this.value,
          type: this.type,
          title: this.title,
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && result['event'] == 'add') {
          this.getData();
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(EcommercetemplateComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          value: this.value,
          type: this.type,
          title: this.title
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.getData();
        }


      });
    }
  }

  saveData() {

    this.text = 'Processing';
    if (this._form.valid) {

      this._form.value.conditions.forEach(element => {

        if (!this.duplicate) {
          element['uuid'] = this.value;
          element['pagesTitle'] = this.title;
        } else {
          element['uuid'] = this.oldId;
          element['pagesTitle'] = this.titleOld;
        }

        if (this.router.url.includes("/duplicatePage/")) {
          element['uuid'] = this.templateType;
        } else {
          element['pageType'] = this.type;
        }
      });


      this._form.value.conditions.forEach(ele => {
        if (ele.type == 'table' && (ele.customField33 == 2 || ele.customField33 == 4 || ele.customField33 == 13 || ele.customField33 == 10)) {
          ele.customField32 = JSON.stringify(this.priceplandata);
        }
        if (ele.type == 'table' && ele.customField33 == 3) {
          ele.customField31 = JSON.stringify(this.priceplandata1);
        }
        if (ele.type == 'table' && ele.customField33 == 1) {
          ele.customField34 = JSON.stringify(this.tabledata);
        }
        if (ele.type == 'table' && ele.customField33 == 5) {
          ele.customField30 = JSON.stringify(this.priceplandata2);
        }
        if (ele.type == 'table' && ele.customField33 == 6) {
          ele.customField29 = JSON.stringify(this.priceplandata3);
        }
        if (ele.type == 'table' && ele.customField33 == 7) {
          ele.customField30 = JSON.stringify(this.priceplandata2);
        }
        if (ele.type == 'table' && ele.customField33 == 9) {
          ele.customField30 = JSON.stringify(this.priceplandata4);
        }
        if (ele.type == 'table' && ele.customField33 == 11) {
          ele.customField30 = JSON.stringify(this.priceplandata1);
        }
        if (ele.type == 'table' && ele.customField33 == 12) {
          ele.customField30 = JSON.stringify(this.priceplandata2);
        }
        if (ele.type == 'table' && ele.customField33 == 15) {
          ele.customField30 = JSON.stringify(this.priceplandata5);
        }
        if (ele.type == 'table' && ele.customField33 == 16) {
          ele.customField30 = JSON.stringify(this.priceplandata6);
        }
      });

      this.homePageService.saveLayout(this._form.value.conditions).subscribe(
        (response) => {
          if (this._form.valid) {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', {
                panelClass: 'success',
                verticalPosition: 'bottom',
                duration: 500,
              });
              this.text = 'Save';

              if (this.type == 4) {
                this.router.navigate([`blogSection`]);
              } else if (this.type == 3) {
                this.router.navigate([`/`]);
              } else {
                this.router.navigate([`/`]);
              }

            } else {
              this.snackBar.open(response['status_message'], '×', {
                panelClass: 'error',
                verticalPosition: 'bottom',
                duration: 500,
              });
            }
          }
        },
        (err) => {
          this.text = 'Save';
        }
      );
    } else {
      this.text = 'Save';
      this._form.markAllAsTouched();
    }
  }

  setDefaultIndex(i) {
    this.defaultIndex = i;
  }

  scrollToFormSection(index: number): void {
    const section = document.getElementById('formSection-' + index);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}
